import * as i0 from '@angular/core';
import { InjectionToken, inject, Injectable, Input, Component, makeEnvironmentProviders } from '@angular/core';
import { throwError, of, Observable, combineLatest, catchError as catchError$1, retry, map as map$1, firstValueFrom, filter, switchMap } from 'rxjs';
import { KeyService } from '@athleticnet/athletic-live-api-models';
import { map, catchError } from 'rxjs/operators';
import { HttpClient, provideHttpClient } from '@angular/common/http';
import { DateTime } from 'luxon';
import { Database } from '@angular/fire/database';
import { onValue, ref, query, orderByChild, equalTo } from 'firebase/database';
import * as i3 from '@ng-select/ng-select';
import { NgSelectModule } from '@ng-select/ng-select';
import * as i4 from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import * as i2 from '@ng-bootstrap/ng-bootstrap';
const _c0 = () => ["fas", "times"];
const _c1 = () => ["fas", "save"];
const _c2 = () => ["fas", "spinner"];
const _forTrack0 = ($index, $item) => $item.id;
const _forTrack1 = ($index, $item) => $item.value;
function SetDataModalComponent_Conditional_7_Conditional_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10)(1, "label", 11);
    i0.ɵɵtext(2, "Select Scoreboard");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "ng-select", 12);
    i0.ɵɵtwoWayListener("ngModelChange", function SetDataModalComponent_Conditional_7_Conditional_0_Conditional_0_Template_ng_select_ngModelChange_3_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(3);
      i0.ɵɵtwoWayBindingSet(ctx_r1.tempDocumentOptions.documentId, $event) || (ctx_r1.tempDocumentOptions.documentId = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementStart(4, "ng-option", 13);
    i0.ɵɵtext(5, "Scoreboard 1");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "ng-option", 14);
    i0.ɵɵtext(7, "Scoreboard 2");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.tempDocumentOptions.documentId);
    i0.ɵɵproperty("searchable", false)("clearable", false);
  }
}
function SetDataModalComponent_Conditional_7_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, SetDataModalComponent_Conditional_7_Conditional_0_Conditional_0_Template, 8, 3, "div", 10);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ctx_r1.hasMultipleScoreboardsRole ? 0 : -1);
  }
}
function SetDataModalComponent_Conditional_7_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Not available for XC meets. Please select a track meet.");
    i0.ɵɵelementEnd();
  }
}
function SetDataModalComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, SetDataModalComponent_Conditional_7_Conditional_0_Template, 1, 1)(1, SetDataModalComponent_Conditional_7_Conditional_1_Template, 2, 0, "span");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional(!ctx_r1.setDataOptionsService.isXcMeet ? 0 : 1);
  }
}
function SetDataModalComponent_Conditional_8_Case_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5)(1, "div", 10)(2, "label", 15);
    i0.ɵɵtext(3, "Race Title");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "input", 16);
    i0.ɵɵlistener("ngModelChange", function SetDataModalComponent_Conditional_8_Case_0_Template_input_ngModelChange_4_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.tempDocumentOptions.documentOptions.set("raceTitle", $event));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 10)(6, "label", 17);
    i0.ɵɵtext(7, "Start Offset");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "input", 18);
    i0.ɵɵlistener("ngModelChange", function SetDataModalComponent_Conditional_8_Case_0_Template_input_ngModelChange_8_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.tempDocumentOptions.documentOptions.set("startOffset", $event));
    });
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngModel", ctx_r1.tempDocumentOptions.documentOptions.get("raceTitle"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngModel", ctx_r1.tempDocumentOptions.documentOptions.get("startOffset"));
  }
}
function SetDataModalComponent_Conditional_8_Case_1_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10)(1, "label", 11);
    i0.ɵɵtext(2, "Select Scoreboard");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "ng-select", 12);
    i0.ɵɵtwoWayListener("ngModelChange", function SetDataModalComponent_Conditional_8_Case_1_Conditional_0_Template_ng_select_ngModelChange_3_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(3);
      i0.ɵɵtwoWayBindingSet(ctx_r1.tempDocumentOptions.documentId, $event) || (ctx_r1.tempDocumentOptions.documentId = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementStart(4, "ng-option", 13);
    i0.ɵɵtext(5, "Scoreboard 1");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "ng-option", 14);
    i0.ɵɵtext(7, "Scoreboard 2");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.tempDocumentOptions.documentId);
    i0.ɵɵproperty("searchable", false)("clearable", false);
  }
}
function SetDataModalComponent_Conditional_8_Case_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Not available for XC meets. Please select a track meet.");
    i0.ɵɵelementEnd();
  }
}
function SetDataModalComponent_Conditional_8_Case_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, SetDataModalComponent_Conditional_8_Case_1_Conditional_0_Template, 8, 3, "div", 10)(1, SetDataModalComponent_Conditional_8_Case_1_Conditional_1_Template, 2, 0, "span");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(!ctx_r1.setDataOptionsService.isXcMeet ? 0 : 1);
  }
}
function SetDataModalComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, SetDataModalComponent_Conditional_8_Case_0_Template, 9, 2, "div", 5)(1, SetDataModalComponent_Conditional_8_Case_1_Template, 2, 1);
  }
  if (rf & 2) {
    let tmp_1_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional((tmp_1_0 = ctx_r1.model.connectionType) === "manual" ? 0 : tmp_1_0 === "online" ? 1 : -1);
  }
}
function SetDataModalComponent_Conditional_9_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ng-option", 22);
    i0.ɵɵtext(1, "Check In Events");
    i0.ɵɵelementEnd();
  }
}
function SetDataModalComponent_Conditional_9_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ng-option", 24);
    i0.ɵɵtext(1, "Live Track Results");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "ng-option", 25);
    i0.ɵɵtext(3, "Live Track Start Lists");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "ng-option", 26);
    i0.ɵɵtext(5, "Team Score");
    i0.ɵɵelementEnd();
  }
}
function SetDataModalComponent_Conditional_9_Conditional_12_Conditional_0_Conditional_4_For_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ng-option", 33);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r8 = ctx.$implicit;
    i0.ɵɵproperty("value", item_r8.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(item_r8.label);
  }
}
function SetDataModalComponent_Conditional_9_Conditional_12_Conditional_0_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 27)(1, "label", 30);
    i0.ɵɵtext(2, "Select a Heat");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "ng-select", 31);
    i0.ɵɵtwoWayListener("ngModelChange", function SetDataModalComponent_Conditional_9_Conditional_12_Conditional_0_Conditional_4_Template_ng_select_ngModelChange_3_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(4);
      i0.ɵɵtwoWayBindingSet(ctx_r1.tempDocumentOptions.documentSecondaryId, $event) || (ctx_r1.tempDocumentOptions.documentSecondaryId = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementStart(4, "ng-option", 32);
    i0.ɵɵtext(5, "All");
    i0.ɵɵelementEnd();
    i0.ɵɵrepeaterCreate(6, SetDataModalComponent_Conditional_9_Conditional_12_Conditional_0_Conditional_4_For_7_Template, 2, 2, "ng-option", 33, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(3);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.tempDocumentOptions.documentSecondaryId);
    i0.ɵɵproperty("searchable", false)("clearable", false);
    i0.ɵɵadvance(3);
    i0.ɵɵrepeater(ctx_r1.setDataOptionsService.heatsByEvent[ctx_r1.tempDocumentOptions.documentId]);
  }
}
function SetDataModalComponent_Conditional_9_Conditional_12_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 27)(1, "label", 28);
    i0.ɵɵtext(2, "Select an Event");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "ng-select", 29);
    i0.ɵɵtwoWayListener("ngModelChange", function SetDataModalComponent_Conditional_9_Conditional_12_Conditional_0_Template_ng_select_ngModelChange_3_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(3);
      i0.ɵɵtwoWayBindingSet(ctx_r1.tempDocumentOptions.documentId, $event) || (ctx_r1.tempDocumentOptions.documentId = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("change", function SetDataModalComponent_Conditional_9_Conditional_12_Conditional_0_Template_ng_select_change_3_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.updateTeamsForEvent(true));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵconditionalCreate(4, SetDataModalComponent_Conditional_9_Conditional_12_Conditional_0_Conditional_4_Template, 8, 3, "div", 27);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("items", ctx_r1.setDataOptionsService.compiledResultOptions);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.tempDocumentOptions.documentId);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.setDataOptionsService.heatsByEvent[ctx_r1.tempDocumentOptions.documentId] && !ctx_r1.setDataOptionsService.isXcMeet ? 4 : -1);
  }
}
function SetDataModalComponent_Conditional_9_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, SetDataModalComponent_Conditional_9_Conditional_12_Conditional_0_Template, 5, 3);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ctx_r1.setDataOptionsService.eventSummaries && ctx_r1.setDataOptionsService.eventSummaries.length > 0 ? 0 : -1);
  }
}
function SetDataModalComponent_Conditional_9_Conditional_13_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 38)(1, "label", 39);
    i0.ɵɵtext(2, "Team");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "ng-select", 40);
    i0.ɵɵlistener("ngModelChange", function SetDataModalComponent_Conditional_9_Conditional_13_Conditional_8_Template_ng_select_ngModelChange_3_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.tempDocumentOptions.documentOptions.set("teamId", $event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("items", ctx_r1.setDataOptionsService.teamsByEvent[ctx_r1.tempDocumentOptions.documentId])("ngModel", ctx_r1.tempDocumentOptions.documentOptions.get("teamId") ?? "");
  }
}
function SetDataModalComponent_Conditional_9_Conditional_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 27)(1, "label", 34);
    i0.ɵɵtext(2, "Sort Method");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "ng-select", 35);
    i0.ɵɵlistener("ngModelChange", function SetDataModalComponent_Conditional_9_Conditional_13_Template_ng_select_ngModelChange_3_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.tempDocumentOptions.documentOptions.set("sortMethod", $event));
    });
    i0.ɵɵelementStart(4, "ng-option", 36);
    i0.ɵɵtext(5, "Default");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "ng-option", 37);
    i0.ɵɵtext(7, "By Team");
    i0.ɵɵelementEnd()()();
    i0.ɵɵconditionalCreate(8, SetDataModalComponent_Conditional_9_Conditional_13_Conditional_8_Template, 4, 2, "div", 38);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngModel", ctx_r1.tempDocumentOptions.documentOptions.get("sortMethod") ?? "")("searchable", false)("clearable", false);
    i0.ɵɵadvance(5);
    i0.ɵɵconditional(ctx_r1.setDataOptionsService.teamsByEvent[ctx_r1.tempDocumentOptions.documentId] && ctx_r1.tempDocumentOptions.documentOptions.get("sortMethod") === "byTeam" ? 8 : -1);
  }
}
function SetDataModalComponent_Conditional_9_Conditional_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10)(1, "label", 11);
    i0.ɵɵtext(2, "Select Scoreboard");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "ng-select", 12);
    i0.ɵɵtwoWayListener("ngModelChange", function SetDataModalComponent_Conditional_9_Conditional_14_Template_ng_select_ngModelChange_3_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const ctx_r1 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r1.tempDocumentOptions.documentId, $event) || (ctx_r1.tempDocumentOptions.documentId = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementStart(4, "ng-option", 13);
    i0.ɵɵtext(5, "Scoreboard 1");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "ng-option", 14);
    i0.ɵɵtext(7, "Scoreboard 2");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.tempDocumentOptions.documentId);
    i0.ɵɵproperty("searchable", false)("clearable", false);
  }
}
function SetDataModalComponent_Conditional_9_Conditional_15_Conditional_4_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ng-option", 33);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r13 = ctx.$implicit;
    i0.ɵɵproperty("value", item_r13.id + "|||" + item_r13.name);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(item_r13.name);
  }
}
function SetDataModalComponent_Conditional_9_Conditional_15_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, SetDataModalComponent_Conditional_9_Conditional_15_Conditional_4_For_1_Template, 2, 2, "ng-option", 33, _forTrack0);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵrepeater(ctx_r1.setDataOptionsService.meetList.meetScores);
  }
}
function SetDataModalComponent_Conditional_9_Conditional_15_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10)(1, "label", 41);
    i0.ɵɵtext(2, "Select Score Group");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "ng-select", 42);
    i0.ɵɵtwoWayListener("ngModelChange", function SetDataModalComponent_Conditional_9_Conditional_15_Template_ng_select_ngModelChange_3_listener($event) {
      i0.ɵɵrestoreView(_r12);
      const ctx_r1 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r1.tempDocumentOptions.documentId, $event) || (ctx_r1.tempDocumentOptions.documentId = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵconditionalCreate(4, SetDataModalComponent_Conditional_9_Conditional_15_Conditional_4_Template, 2, 0);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.tempDocumentOptions.documentId);
    i0.ɵɵproperty("searchable", false)("clearable", false);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.setDataOptionsService.meetList ? 4 : -1);
  }
}
function SetDataModalComponent_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "div", 5)(2, "div", 10)(3, "label", 19);
    i0.ɵɵtext(4, "Document Type");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "ng-select", 20);
    i0.ɵɵtwoWayListener("ngModelChange", function SetDataModalComponent_Conditional_9_Template_ng_select_ngModelChange_5_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.tempDocumentOptions.documentType, $event) || (ctx_r1.tempDocumentOptions.documentType = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("change", function SetDataModalComponent_Conditional_9_Template_ng_select_change_5_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.clearExtraResultOptions());
    });
    i0.ɵɵelementStart(6, "ng-option", 21);
    i0.ɵɵtext(7, "Final Result");
    i0.ɵɵelementEnd();
    i0.ɵɵconditionalCreate(8, SetDataModalComponent_Conditional_9_Conditional_8_Template, 2, 0, "ng-option", 22);
    i0.ɵɵelementStart(9, "ng-option", 23);
    i0.ɵɵtext(10, "Heat/Flight Start List");
    i0.ɵɵelementEnd();
    i0.ɵɵconditionalCreate(11, SetDataModalComponent_Conditional_9_Conditional_11_Template, 6, 0);
    i0.ɵɵelementEnd()();
    i0.ɵɵconditionalCreate(12, SetDataModalComponent_Conditional_9_Conditional_12_Template, 1, 1);
    i0.ɵɵconditionalCreate(13, SetDataModalComponent_Conditional_9_Conditional_13_Template, 9, 4);
    i0.ɵɵconditionalCreate(14, SetDataModalComponent_Conditional_9_Conditional_14_Template, 8, 3, "div", 10);
    i0.ɵɵconditionalCreate(15, SetDataModalComponent_Conditional_9_Conditional_15_Template, 5, 4, "div", 10);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.tempDocumentOptions.documentType);
    i0.ɵɵproperty("searchable", false)("clearable", false);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r1.hasCheckInRole && !ctx_r1.setDataOptionsService.isXcMeet ? 8 : -1);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(!ctx_r1.setDataOptionsService.isXcMeet ? 11 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.tempDocumentOptions.documentType === "finalResult" || ctx_r1.tempDocumentOptions.documentType === "startList" ? 12 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.tempDocumentOptions.documentType === "startList" && ctx_r1.tempDocumentOptions.documentId && ctx_r1.tempDocumentOptions.documentId.includes("|||") ? 13 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((ctx_r1.tempDocumentOptions.documentType === "liveTrackResult" || ctx_r1.tempDocumentOptions.documentType === "liveTrackStartList") && ctx_r1.hasMultipleScoreboardsRole ? 14 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.tempDocumentOptions.documentType === "teamScore" ? 15 : -1);
  }
}
function SetDataModalComponent_Conditional_10_Conditional_0_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 27)(1, "label", 45);
    i0.ɵɵtext(2, "Select Split");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "ng-select", 46);
    i0.ɵɵtwoWayListener("ngModelChange", function SetDataModalComponent_Conditional_10_Conditional_0_Conditional_5_Template_ng_select_ngModelChange_3_listener($event) {
      i0.ɵɵrestoreView(_r15);
      const ctx_r1 = i0.ɵɵnextContext(3);
      i0.ɵɵtwoWayBindingSet(ctx_r1.tempDocumentOptions.documentId, $event) || (ctx_r1.tempDocumentOptions.documentId = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("items", ctx_r1.setDataOptionsService.xcSummaryOptionsByEvent[ctx_r1.xcSummarySelectedRace]);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.tempDocumentOptions.documentId);
  }
}
function SetDataModalComponent_Conditional_10_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5)(1, "div", 27)(2, "label", 43);
    i0.ɵɵtext(3, "Select Race");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "ng-select", 44);
    i0.ɵɵtwoWayListener("ngModelChange", function SetDataModalComponent_Conditional_10_Conditional_0_Template_ng_select_ngModelChange_4_listener($event) {
      i0.ɵɵrestoreView(_r14);
      const ctx_r1 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r1.xcSummarySelectedRace, $event) || (ctx_r1.xcSummarySelectedRace = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("change", function SetDataModalComponent_Conditional_10_Conditional_0_Template_ng_select_change_4_listener() {
      i0.ɵɵrestoreView(_r14);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.updateXcSummaryFilter());
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵconditionalCreate(5, SetDataModalComponent_Conditional_10_Conditional_0_Conditional_5_Template, 4, 2, "div", 27);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("items", ctx_r1.setDataOptionsService.xcSummaryRaces);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.xcSummarySelectedRace);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.xcSummarySelectedRace && ctx_r1.setDataOptionsService.xcSummaryOptionsByEvent[ctx_r1.xcSummarySelectedRace] && ctx_r1.setDataOptionsService.xcSummaryOptionsByEvent[ctx_r1.xcSummarySelectedRace].length > 1 ? 5 : -1);
  }
}
function SetDataModalComponent_Conditional_10_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Not available for track meets. Please select an XC meet.");
    i0.ɵɵelementEnd();
  }
}
function SetDataModalComponent_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, SetDataModalComponent_Conditional_10_Conditional_0_Template, 6, 3, "div", 5)(1, SetDataModalComponent_Conditional_10_Conditional_1_Template, 2, 0, "span");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r1.setDataOptionsService.isXcMeet ? 0 : 1);
  }
}
function SetDataModalComponent_Conditional_11_Conditional_0_Conditional_5_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ng-option", 53);
    i0.ɵɵtext(1, "Specific Competition Area");
    i0.ɵɵelementEnd();
  }
}
function SetDataModalComponent_Conditional_11_Conditional_0_Conditional_5_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ng-option", 54);
    i0.ɵɵtext(1, "Specific Athlete");
    i0.ɵɵelementEnd();
  }
}
function SetDataModalComponent_Conditional_11_Conditional_0_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 27)(1, "label", 50);
    i0.ɵɵtext(2, "Data Source");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "ng-select", 51);
    i0.ɵɵtwoWayListener("ngModelChange", function SetDataModalComponent_Conditional_11_Conditional_0_Conditional_5_Template_ng_select_ngModelChange_3_listener($event) {
      i0.ɵɵrestoreView(_r17);
      const ctx_r1 = i0.ɵɵnextContext(3);
      i0.ɵɵtwoWayBindingSet(ctx_r1.tempDocumentOptions.documentType, $event) || (ctx_r1.tempDocumentOptions.documentType = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("change", function SetDataModalComponent_Conditional_11_Conditional_0_Conditional_5_Template_ng_select_change_3_listener() {
      i0.ɵɵrestoreView(_r17);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.clearExtraResultOptions());
    });
    i0.ɵɵelementStart(4, "ng-option", 52);
    i0.ɵɵtext(5, "Live Event");
    i0.ɵɵelementEnd();
    i0.ɵɵconditionalCreate(6, SetDataModalComponent_Conditional_11_Conditional_0_Conditional_5_Conditional_6_Template, 2, 0, "ng-option", 53);
    i0.ɵɵconditionalCreate(7, SetDataModalComponent_Conditional_11_Conditional_0_Conditional_5_Conditional_7_Template, 2, 0, "ng-option", 54);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.tempDocumentOptions.documentType);
    i0.ɵɵproperty("searchable", false)("clearable", false);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r1.setDataOptionsService.fieldCompetitionAreasByEvent[ctx_r1.tempDocumentOptions.documentId] ? 6 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.model.modelId === "individualFieldResult" && ctx_r1.setDataOptionsService.fieldAthletesByEvent[ctx_r1.tempDocumentOptions.documentId] ? 7 : -1);
  }
}
function SetDataModalComponent_Conditional_11_Conditional_0_Conditional_6_For_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ng-option", 33);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r19 = ctx.$implicit;
    i0.ɵɵproperty("value", item_r19.value + "|||" + item_r19.label);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r19.label, " ");
  }
}
function SetDataModalComponent_Conditional_11_Conditional_0_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 49)(1, "label", 55);
    i0.ɵɵtext(2, "Competition Area");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "ng-select", 56);
    i0.ɵɵtwoWayListener("ngModelChange", function SetDataModalComponent_Conditional_11_Conditional_0_Conditional_6_Template_ng_select_ngModelChange_3_listener($event) {
      i0.ɵɵrestoreView(_r18);
      const ctx_r1 = i0.ɵɵnextContext(3);
      i0.ɵɵtwoWayBindingSet(ctx_r1.tempDocumentOptions.documentSecondaryId, $event) || (ctx_r1.tempDocumentOptions.documentSecondaryId = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵrepeaterCreate(4, SetDataModalComponent_Conditional_11_Conditional_0_Conditional_6_For_5_Template, 2, 2, "ng-option", 33, _forTrack1);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.tempDocumentOptions.documentSecondaryId);
    i0.ɵɵproperty("searchable", false)("clearable", false);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.setDataOptionsService.fieldCompetitionAreasByEvent[ctx_r1.tempDocumentOptions.documentId]);
  }
}
function SetDataModalComponent_Conditional_11_Conditional_0_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 49)(1, "label", 57);
    i0.ɵɵtext(2, "Athlete");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "ng-select", 58);
    i0.ɵɵlistener("ngModelChange", function SetDataModalComponent_Conditional_11_Conditional_0_Conditional_7_Template_ng_select_ngModelChange_3_listener($event) {
      i0.ɵɵrestoreView(_r20);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.tempDocumentOptions.documentOptions.set("athleteId", $event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("items", ctx_r1.setDataOptionsService.fieldAthletesByEvent[ctx_r1.tempDocumentOptions.documentId])("ngModel", ctx_r1.tempDocumentOptions.documentOptions.get("athleteId"));
  }
}
function SetDataModalComponent_Conditional_11_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5)(1, "div", 27)(2, "label", 47);
    i0.ɵɵtext(3, "Select Event");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "ng-select", 48);
    i0.ɵɵtwoWayListener("ngModelChange", function SetDataModalComponent_Conditional_11_Conditional_0_Template_ng_select_ngModelChange_4_listener($event) {
      i0.ɵɵrestoreView(_r16);
      const ctx_r1 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r1.tempDocumentOptions.documentId, $event) || (ctx_r1.tempDocumentOptions.documentId = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("change", function SetDataModalComponent_Conditional_11_Conditional_0_Template_ng_select_change_4_listener() {
      i0.ɵɵrestoreView(_r16);
      const ctx_r1 = i0.ɵɵnextContext(2);
      ctx_r1.resetFieldDocumentType();
      ctx_r1.getFieldCompetitionAreas();
      return i0.ɵɵresetView(ctx_r1.updateAthletesForEvent(true));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵconditionalCreate(5, SetDataModalComponent_Conditional_11_Conditional_0_Conditional_5_Template, 8, 5, "div", 27);
    i0.ɵɵconditionalCreate(6, SetDataModalComponent_Conditional_11_Conditional_0_Conditional_6_Template, 6, 3, "div", 49);
    i0.ɵɵconditionalCreate(7, SetDataModalComponent_Conditional_11_Conditional_0_Conditional_7_Template, 4, 2, "div", 49);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("items", ctx_r1.setDataOptionsService.fieldSelectOptions);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.tempDocumentOptions.documentId);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.setDataOptionsService.fieldCompetitionAreasByEvent[ctx_r1.tempDocumentOptions.documentId] || ctx_r1.setDataOptionsService.fieldAthletesByEvent[ctx_r1.tempDocumentOptions.documentId] && ctx_r1.model.modelId === "individualFieldResult" ? 5 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.tempDocumentOptions.documentType === "fieldEventCompetitionArea" && ctx_r1.setDataOptionsService.fieldCompetitionAreasByEvent[ctx_r1.tempDocumentOptions.documentId] ? 6 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.model.modelId === "individualFieldResult" && ctx_r1.tempDocumentOptions.documentType === "fieldEventAthlete" && ctx_r1.setDataOptionsService.fieldAthletesByEvent[ctx_r1.tempDocumentOptions.documentId] ? 7 : -1);
  }
}
function SetDataModalComponent_Conditional_11_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Not available for XC meets. Please select a track meet.");
    i0.ɵɵelementEnd();
  }
}
function SetDataModalComponent_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, SetDataModalComponent_Conditional_11_Conditional_0_Template, 8, 5, "div", 5)(1, SetDataModalComponent_Conditional_11_Conditional_1_Template, 2, 0, "span");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional(!ctx_r1.setDataOptionsService.isXcMeet ? 0 : 1);
  }
}
function SetDataModalComponent_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5)(1, "div", 10)(2, "label", 59);
    i0.ɵɵtext(3, "Line 1");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "input", 60);
    i0.ɵɵlistener("ngModelChange", function SetDataModalComponent_Conditional_12_Template_input_ngModelChange_4_listener($event) {
      i0.ɵɵrestoreView(_r21);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.tempDocumentOptions.documentOptions.set("lineOne", $event));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 10)(6, "label", 61);
    i0.ɵɵtext(7, "Line 2");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "input", 62);
    i0.ɵɵlistener("ngModelChange", function SetDataModalComponent_Conditional_12_Template_input_ngModelChange_8_listener($event) {
      i0.ɵɵrestoreView(_r21);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.tempDocumentOptions.documentOptions.set("lineTwo", $event));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "div", 10)(10, "label", 63);
    i0.ɵɵtext(11, "Line 3");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "input", 64);
    i0.ɵɵlistener("ngModelChange", function SetDataModalComponent_Conditional_12_Template_input_ngModelChange_12_listener($event) {
      i0.ɵɵrestoreView(_r21);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.tempDocumentOptions.documentOptions.set("lineThree", $event));
    });
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngModel", ctx_r1.tempDocumentOptions.documentOptions.get("lineOne") ?? "");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngModel", ctx_r1.tempDocumentOptions.documentOptions.get("lineTwo") ?? "");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngModel", ctx_r1.tempDocumentOptions.documentOptions.get("lineThree") ?? "");
  }
}
function SetDataModalComponent_Conditional_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fa-icon", 8);
    i0.ɵɵtext(1, "Save ");
  }
  if (rf & 2) {
    i0.ɵɵproperty("icon", i0.ɵɵpureFunction0(2, _c1))("fixedWidth", true);
  }
}
function SetDataModalComponent_Conditional_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fa-icon", 65);
    i0.ɵɵtext(1, "Saving... ");
  }
  if (rf & 2) {
    i0.ɵɵproperty("icon", i0.ɵɵpureFunction0(2, _c2))("fixedWidth", true);
  }
}
function SelectedDataComponent_Conditional_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵdomElementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵdomElementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.model.documentValue);
  }
}
function SelectedDataComponent_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵdomElementStart(0, "span");
    i0.ɵɵtext(1, "Online - Uses AthleticLIVE scoreboard data \xA0\xA0");
    i0.ɵɵdomElementEnd();
  }
}
function SelectedDataComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, SelectedDataComponent_Conditional_0_Conditional_0_Template, 2, 1, "span")(1, SelectedDataComponent_Conditional_0_Conditional_1_Template, 2, 0, "span");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.hasMultipleScoreboardsRole && ctx_r0.model.documentId ? 0 : 1);
  }
}
function SelectedDataComponent_Conditional_1_Conditional_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵdomElementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵdomElementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.model.documentValue);
  }
}
function SelectedDataComponent_Conditional_1_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵdomElementStart(0, "span");
    i0.ɵɵtext(1, "Online - Uses AthleticLIVE scoreboard data \xA0\xA0");
    i0.ɵɵdomElementEnd();
  }
}
function SelectedDataComponent_Conditional_1_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, SelectedDataComponent_Conditional_1_Conditional_0_Conditional_0_Template, 2, 1, "span")(1, SelectedDataComponent_Conditional_1_Conditional_0_Conditional_1_Template, 2, 0, "span");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ctx_r0.hasMultipleScoreboardsRole && ctx_r0.model.documentId ? 0 : 1);
  }
}
function SelectedDataComponent_Conditional_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵdomElementStart(0, "span")(1, "strong");
    i0.ɵɵtext(2, "Race Title");
    i0.ɵɵdomElementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵdomElementEnd();
    i0.ɵɵtext(4, "\xA0\xA0 ");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(": ", ctx_r0.model.documentOptions.get("raceTitle"));
  }
}
function SelectedDataComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, SelectedDataComponent_Conditional_1_Conditional_0_Template, 2, 1)(1, SelectedDataComponent_Conditional_1_Conditional_1_Template, 5, 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.model.connectionType === "online" ? 0 : ctx_r0.model.connectionType === "manual" ? 1 : -1);
  }
}
function SelectedDataComponent_Conditional_2_Conditional_2_Conditional_4_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵdomElementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵdomElementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.model.documentValue);
  }
}
function SelectedDataComponent_Conditional_2_Conditional_2_Conditional_4_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵdomElementStart(0, "span");
    i0.ɵɵtext(1, "Online - Uses AthleticLIVE scoreboard data");
    i0.ɵɵdomElementEnd();
  }
}
function SelectedDataComponent_Conditional_2_Conditional_2_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, SelectedDataComponent_Conditional_2_Conditional_2_Conditional_4_Conditional_0_Template, 2, 1, "span")(1, SelectedDataComponent_Conditional_2_Conditional_2_Conditional_4_Conditional_1_Template, 2, 0, "span");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵconditional(ctx_r0.hasMultipleScoreboardsRole && ctx_r0.model.documentId ? 0 : 1);
  }
}
function SelectedDataComponent_Conditional_2_Conditional_2_Conditional_5_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵdomElementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵdomElementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2("", ctx_r0.model.documentValue, " - Heat ", ctx_r0.model.documentSecondaryId);
  }
}
function SelectedDataComponent_Conditional_2_Conditional_2_Conditional_5_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵdomElementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵdomElementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.model.documentValue);
  }
}
function SelectedDataComponent_Conditional_2_Conditional_2_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, SelectedDataComponent_Conditional_2_Conditional_2_Conditional_5_Conditional_0_Template, 2, 2, "span")(1, SelectedDataComponent_Conditional_2_Conditional_2_Conditional_5_Conditional_1_Template, 2, 1, "span");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵconditional(ctx_r0.model.documentSecondaryId && ctx_r0.model.documentSecondaryId !== "all" && (ctx_r0.model.documentType == "startList" || ctx_r0.model.documentType == "finalResult") && !(ctx_r0.setDataOptionsService.isXcMeet && ctx_r0.model.documentType == "startList") ? 0 : 1);
  }
}
function SelectedDataComponent_Conditional_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵdomElementStart(0, "div", 3)(1, "div", 4);
    i0.ɵɵtext(2);
    i0.ɵɵdomElementEnd()();
    i0.ɵɵdomElementStart(3, "span");
    i0.ɵɵconditionalCreate(4, SelectedDataComponent_Conditional_2_Conditional_2_Conditional_4_Template, 2, 1)(5, SelectedDataComponent_Conditional_2_Conditional_2_Conditional_5_Template, 2, 1);
    i0.ɵɵdomElementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.documentTypeToLabel(ctx_r0.model.documentType), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.model.documentType === "liveTrackResult" || ctx_r0.model.documentType === "liveTrackStartList" ? 4 : 5);
  }
}
function SelectedDataComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵdomElementStart(0, "div", 0)(1, "div", 2);
    i0.ɵɵconditionalCreate(2, SelectedDataComponent_Conditional_2_Conditional_2_Template, 6, 2);
    i0.ɵɵdomElementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.model.documentType ? 2 : -1);
  }
}
function SelectedDataComponent_Conditional_3_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵdomElementStart(0, "span")(1, "strong");
    i0.ɵɵtext(2, "Race - Split:");
    i0.ɵɵdomElementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵdomElementEnd();
    i0.ɵɵtext(4, "\xA0\xA0 ");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.model.documentValue);
  }
}
function SelectedDataComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, SelectedDataComponent_Conditional_3_Conditional_0_Template, 5, 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.model.documentId ? 0 : -1);
  }
}
function SelectedDataComponent_Conditional_4_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵdomElementStart(0, "div", 3)(1, "div", 4);
    i0.ɵɵtext(2);
    i0.ɵɵdomElementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.documentTypeToLabel(ctx_r0.model.documentType), " ");
  }
}
function SelectedDataComponent_Conditional_4_Conditional_4_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.model.documentValue, " ");
  }
}
function SelectedDataComponent_Conditional_4_Conditional_4_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵdomElementStart(0, "strong");
    i0.ɵɵtext(1, "Event:\xA0");
    i0.ɵɵdomElementEnd();
    i0.ɵɵtext(2);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.model.documentValue.split("|||")[0], " ");
  }
}
function SelectedDataComponent_Conditional_4_Conditional_4_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵdomElementStart(0, "strong");
    i0.ɵɵtext(1, "Event:\xA0");
    i0.ɵɵdomElementEnd();
    i0.ɵɵtext(2);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.model.documentValue.split("|||")[0], " ");
  }
}
function SelectedDataComponent_Conditional_4_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, SelectedDataComponent_Conditional_4_Conditional_4_Conditional_0_Template, 1, 1)(1, SelectedDataComponent_Conditional_4_Conditional_4_Conditional_1_Template, 3, 1)(2, SelectedDataComponent_Conditional_4_Conditional_4_Conditional_2_Template, 3, 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ctx_r0.model.documentType === "liveFieldEvent" ? 0 : ctx_r0.model.documentType === "fieldEventCompetitionArea" ? 1 : ctx_r0.model.documentType === "fieldEventAthlete" ? 2 : -1);
  }
}
function SelectedDataComponent_Conditional_4_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0, " \xA0\xA0");
    i0.ɵɵdomElementStart(1, "strong");
    i0.ɵɵtext(2, "Flight:\xA0");
    i0.ɵɵdomElementEnd();
    i0.ɵɵtext(3);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.model.documentValue.split("|||")[1], " ");
  }
}
function SelectedDataComponent_Conditional_4_Conditional_6_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.model.documentValue.split("|||")[1], " ");
  }
}
function SelectedDataComponent_Conditional_4_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0, " \xA0\xA0");
    i0.ɵɵdomElementStart(1, "strong");
    i0.ɵɵtext(2, "Athlete:\xA0");
    i0.ɵɵdomElementEnd();
    i0.ɵɵconditionalCreate(3, SelectedDataComponent_Conditional_4_Conditional_6_Conditional_3_Template, 1, 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r0.model.documentOptions && ctx_r0.model.documentOptions.get("athleteId") ? 3 : -1);
  }
}
function SelectedDataComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵdomElementStart(0, "div", 0)(1, "div", 2);
    i0.ɵɵconditionalCreate(2, SelectedDataComponent_Conditional_4_Conditional_2_Template, 3, 1, "div", 3);
    i0.ɵɵdomElementStart(3, "span");
    i0.ɵɵconditionalCreate(4, SelectedDataComponent_Conditional_4_Conditional_4_Template, 3, 1);
    i0.ɵɵconditionalCreate(5, SelectedDataComponent_Conditional_4_Conditional_5_Template, 4, 1);
    i0.ɵɵconditionalCreate(6, SelectedDataComponent_Conditional_4_Conditional_6_Template, 4, 1);
    i0.ɵɵdomElementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.model.documentType ? 2 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.model.documentId ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.model.documentType === "fieldEventCompetitionArea" && ctx_r0.model.documentSecondaryId ? 5 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.model.documentType === "fieldEventAthlete" ? 6 : -1);
  }
}
function SelectedDataComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵdomElementStart(0, "div", 1)(1, "div")(2, "div")(3, "strong");
    i0.ɵɵtext(4, "Line 1:\xA0");
    i0.ɵɵdomElementEnd();
    i0.ɵɵtext(5);
    i0.ɵɵdomElementEnd();
    i0.ɵɵdomElementStart(6, "div")(7, "strong");
    i0.ɵɵtext(8, "Line 2:\xA0");
    i0.ɵɵdomElementEnd();
    i0.ɵɵtext(9);
    i0.ɵɵdomElementEnd();
    i0.ɵɵdomElementStart(10, "div")(11, "strong");
    i0.ɵɵtext(12, "Line 3:\xA0");
    i0.ɵɵdomElementEnd();
    i0.ɵɵtext(13);
    i0.ɵɵdomElementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", (ctx_r0.model.documentOptions == null ? null : ctx_r0.model.documentOptions.get("lineOne")) ?? "-", " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", (ctx_r0.model.documentOptions == null ? null : ctx_r0.model.documentOptions.get("lineTwo")) ?? "-", " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", (ctx_r0.model.documentOptions == null ? null : ctx_r0.model.documentOptions.get("lineThree")) ?? "-", " ");
  }
}
class HttpHelperService {
  static handleError(error) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError('Something bad happened; please try again later.');
  }
}

// Injection token for API configuration
const ATHLETIC_LIVE_API_CONFIG = /*#__PURE__*/new InjectionToken('ATHLETIC_LIVE_API_CONFIG');
const keyService$1 = new KeyService();
let AthleticLiveElasticApiService = /*#__PURE__*/(() => {
  class AthleticLiveElasticApiService {
    constructor() {
      this.http = inject(HttpClient);
      this.config = inject(ATHLETIC_LIVE_API_CONFIG, {
        optional: true
      });
      this.searchEndpoint = this.config?.searchEndpoint || 'https://athleticlive.blob.core.windows.net/$web';
      this.elasticEndpoint = this.config?.elasticEndpoint || 'https://search.athletic.live';
    }
    getAthleteDetail(id) {
      return this.http.get(this.searchEndpoint + '/athlete_detail/_doc/' + id).pipe(map(data => {
        data = keyService$1.shortToLong(data._source);
        const obj = data;
        return obj;
      }));
    }
    getAthleteList(meetId, searchString) {
      const matchPhrasePrefix = {};
      const meetIdTerm = {};
      matchPhrasePrefix[keyService$1.longKeyToShortKey('name')] = {};
      var allowSearch = false;
      matchPhrasePrefix[keyService$1.longKeyToShortKey('name')] = {
        query: searchString,
        max_expansions: 10,
        slop: 10
      };
      meetIdTerm[keyService$1.longKeyToShortKey('meetId')] = meetId;
      const searchQuery = {
        from: 0,
        size: 1000,
        query: {
          bool: {}
        }
      };
      if (/^(\d+)$/.test(searchString)) {
        searchQuery.query.bool.should = [];
        searchQuery.query.bool.should.push({
          match_phrase_prefix: matchPhrasePrefix
        });
        searchQuery.query.bool.should.push({
          match: {
            cm: {
              query: searchString,
              boost: 5
            }
          }
        });
        searchQuery.query.bool.minimum_should_match = 1;
        allowSearch = true;
      } else {
        searchQuery.query.bool.must = {
          match_phrase_prefix: matchPhrasePrefix
        };
        if (searchString.length >= 3) {
          allowSearch = true;
        }
      }
      if (allowSearch) {
        searchQuery.query.bool.filter = {
          term: meetIdTerm
        };
        return this.http.post(this.elasticEndpoint + '/athlete_list/_search', searchQuery).pipe(catchError(HttpHelperService.handleError)).pipe(map(data => {
          const teamLists = [];
          if (data && data.hits) {
            Object.keys(data.hits.hits).forEach(idx => {
              const obj = keyService$1.shortToLong(data.hits.hits[idx]._source);
              const team = obj;
              teamLists.push(team);
            });
          }
          return teamLists;
        }));
      } else {
        const athleteLists = [];
        return of(athleteLists);
      }
    }
    // public getAwardList(id: number): Observable<AwardList> {
    //   return this.http.get<AwardList>(this.searchEndpoint + "/award_list/_doc/" + id)
    //     .pipe(
    //       map((data: any) => {
    //         data = keyService.shortToLong(data._source);
    //         let obj: AwardList = data;
    //         return obj;
    //       })
    //     )
    // }
    //
    // public getAward(id: number): Observable<Award> {
    //   return this.http.get<Award>(this.searchEndpoint + "/award/_doc/" + id)
    //     .pipe(
    //       map((data: any) => {
    //         data = keyService.shortToLong(data._source);
    //         let obj: Award = data;
    //         return obj;
    //       })
    //     )
    // }
    getCombinedEntriesList(id) {
      return this.http.get(this.searchEndpoint + '/combined_entries_list/_doc/' + id).pipe(map(data => {
        data = keyService$1.shortToLong(data._source);
        const obj = data;
        return obj;
      }));
    }
    getCombinedResultsList(id) {
      return this.http.get(this.searchEndpoint + '/combined_results_list/_doc/' + id).pipe(map(data => {
        data = keyService$1.shortToLong(data._source);
        const obj = data;
        return obj;
      }));
    }
    getCombinedWinnersReport(id) {
      return this.http.get(this.searchEndpoint + '/combined_winners_report/_doc/winners' + id).pipe(map(data => {
        data = keyService$1.shortToLong(data._source);
        const obj = data;
        return obj;
      }));
    }
    getDivisionDetail(id) {
      return this.http.get(this.searchEndpoint + '/division_detail/_doc/' + id).pipe(map(data => {
        data = keyService$1.shortToLong(data._source);
        const obj = data;
        return obj;
      }));
    }
    getDivisionList(id) {
      return this.http.get(this.searchEndpoint + '/division_list/_doc/' + id).pipe(map(data => {
        data = keyService$1.shortToLong(data._source);
        const obj = data;
        return obj;
      }));
    }
    // public getEventDetail(id: number): Observable<EventDetail> {
    //   return this.http.get<EventDetail>(this.searchEndpoint + "/event_detail/_doc/" + id)
    //     .pipe(
    //       map((data: any) => {
    //         data = keyService.shortToLong(data._source);
    //         let obj: EventDetail = data;
    //         return obj;
    //       })
    //     )
    // }
    //
    // public getEventSummary(id: number): Observable<EventSummary> {
    //   return this.http.get<EventSummary>(this.searchEndpoint + "/event_summary/_doc/" + id)
    //     .pipe(
    //       map((data: any) => {
    //         data = keyService.shortToLong(data._source);
    //         let obj: EventSummary = data;
    //         return obj;
    //       })
    //     )
    // }
    // public getFieldAppRound(id: number): Observable<FieldAppRound> {
    //   return this.http.get<FieldAppRound>(this.searchEndpoint + "/fieldAppRound/_doc/" + id)
    //     .pipe(
    //       map((data: any) => {
    //         data = keyService.shortToLong(data._source);
    //         let obj: FieldAppRound = data;
    //         return obj;
    //       })
    //     )
    // }
    getFieldAppRoundList(id) {
      return this.http.get(this.searchEndpoint + '/field_app_round_list/_doc/' + id).pipe(map(data => {
        data = keyService$1.shortToLong(data._source);
        const obj = data;
        return obj;
      }));
    }
    getFieldRunRelayReport(id) {
      return this.http.get(this.searchEndpoint + '/field_run_relay_report/_doc/FRR|' + id).pipe(map(data => {
        data = keyService$1.shortToLong(data._source);
        const obj = data;
        return obj;
      }));
    }
    getHorizontalSeriesReport(id) {
      return this.http.get(this.searchEndpoint + '/horizontal_series_report/_doc/HSR|' + id).pipe(map(data => {
        data = keyService$1.shortToLong(data._source);
        const obj = data;
        return obj;
      }));
    }
    getIndividualEntriesList(id) {
      return this.http.get(this.searchEndpoint + '/ind_ent_list/_doc/' + id).pipe(map(data => {
        data = keyService$1.shortToLong(data._source);
        const obj = data;
        return obj;
      }));
    }
    getIndividualHeatsList(id) {
      return this.http.get(this.searchEndpoint + '/ind_heat_list/_doc/' + id).pipe(map(data => {
        data = keyService$1.shortToLong(data._source);
        const obj = data;
        return obj;
      }));
    }
    getIndividualResultsList(id) {
      return this.http.get(this.searchEndpoint + '/ind_res_list/_doc/' + id).pipe(map(data => {
        data = keyService$1.shortToLong(data._source);
        const obj = data;
        return obj;
      }));
    }
    getIndividualRunSplitReport(id, heatNumber) {
      return this.http.get(this.searchEndpoint + '/run_split_report/_doc/IRSR|' + id + (heatNumber ? '-H' + heatNumber : '')).pipe(map(data => {
        data = keyService$1.shortToLong(data._source);
        const obj = data;
        return obj;
      }));
    }
    // public getLatestUpdateList(id: number): Observable<LatestUpdateList> {
    //   return this.http.get<LatestUpdateList>(this.searchEndpoint + "/latest_update_list/_doc/" + id)
    //     .pipe(
    //       map((data: any) => {
    //         data = keyService.shortToLong(data._source);
    //         let obj: LatestUpdateList = data;
    //         return obj;
    //       })
    //     )
    // }
    getMeetArchiveReport(id) {
      return this.http.get(this.searchEndpoint + '/meet_archive_report/_doc/' + id).pipe(map(data => {
        data = keyService$1.shortToLong(data._source);
        const obj = data;
        return obj;
      }));
    }
    /**
     *
     * @param searchIndex meet index to search
     * @param date YYYY-MM-DD
     * @param size
     * @param rangeType lt, lte, gt, gte
     * @param sort desc, asc
     * @param maxDate the max date
     */
    getRangeMeets(searchIndex, date, size = 5, rangeType = 'lt', sort = 'desc', maxDate = '') {
      const publishedSearch = {};
      publishedSearch[keyService$1.longKeyToShortKey('published')] = true;
      const dateRangeSearch = {};
      dateRangeSearch[keyService$1.longKeyToShortKey('meetDates')] = {};
      dateRangeSearch[keyService$1.longKeyToShortKey('meetDates')][rangeType] = date;
      const dateStopSearch = {};
      dateStopSearch[keyService$1.longKeyToShortKey('meetDates')] = {};
      if (maxDate) {
        if (rangeType === 'lt' || rangeType === 'lte') {
          // recent
          dateRangeSearch[keyService$1.longKeyToShortKey('meetDates')]['gt'] = maxDate;
          dateStopSearch[keyService$1.longKeyToShortKey('meetDates')]['gt'] = date;
        } else if (rangeType === 'gt' || rangeType === 'gte') {
          // upcoming
          dateRangeSearch[keyService$1.longKeyToShortKey('meetDates')]['lt'] = maxDate;
          dateStopSearch[keyService$1.longKeyToShortKey('meetDates')]['lt'] = date;
        }
      }
      const sortObj = {};
      sortObj[keyService$1.longKeyToShortKey('meetDates')] = sort;
      const body = {
        size,
        sort: sortObj,
        query: {
          bool: {
            must: [{
              term: publishedSearch
            }, {
              range: dateRangeSearch
            }],
            must_not: [{
              range: dateStopSearch
            }]
          }
        }
      };
      return this.http.post(this.elasticEndpoint + '/' + searchIndex + '_meet_list/_search', body).pipe(catchError(HttpHelperService.handleError)).pipe(map(data => {
        const meetList = [];
        if (data && data.hits) {
          Object.keys(data.hits.hits).forEach(idx => {
            const obj = keyService$1.shortToLong(data.hits.hits[idx]._source);
            const meet = obj;
            meetList.push(meet);
          });
        }
        return meetList;
      }));
    }
    /**
     *
     * @param searchIndex meet index to search
     * @param date YYYY-MM-DD
     * @param locationSearchArea e.g. Wyoming, Canada
     */
    getMeetsByDay(searchIndex, date, countryCodes, states) {
      const publishedSearch = {};
      publishedSearch[keyService$1.longKeyToShortKey('published')] = true;
      const singleDaySearch = {};
      singleDaySearch[keyService$1.longKeyToShortKey('meetDates')] = date;
      const body = {
        size: 500,
        query: {
          bool: {
            must: [{
              term: publishedSearch
            }, {
              term: singleDaySearch
            }]
          }
        }
      };
      if (countryCodes && countryCodes.length > 0) {
        const countryCodeKey = keyService$1.longKeyToShortKey('countryCode');
        const should = countryCodes.map(countryCode => {
          return {
            match: {
              [countryCodeKey]: countryCode
            }
          };
        });
        const query = {
          bool: {
            should
          }
        };
        body.query.bool.must.push(query);
      }
      if (states && states.length > 0) {
        const should = states.map(state => {
          return {
            match: {
              [keyService$1.longKeyToShortKey('locationSearchArea')]: state
            }
          };
        });
        const query = {
          bool: {
            should
          }
        };
        body.query.bool.must.push(query);
      }
      return this.http.post(this.elasticEndpoint + '/' + searchIndex + '_meet_list/_search', body).pipe(catchError(HttpHelperService.handleError)).pipe(map(data => {
        const meetList = [];
        if (data && data.hits) {
          Object.keys(data.hits.hits).forEach(idx => {
            const obj = keyService$1.shortToLong(data.hits.hits[idx]._source);
            const meet = obj;
            meetList.push(meet);
          });
        }
        meetList.sort((a, b) => {
          // remove year from from of name
          return a.longName.localeCompare(b.longName);
        });
        return meetList;
      }));
    }
    getMeetsByName(searchIndex, name, countryCodes, states) {
      const url = this.elasticEndpoint + '/' + searchIndex + '_meet_list/_search';
      const body = {
        size: 50,
        query: {
          function_score: {
            query: {
              bool: {
                must: [{
                  bool: {
                    should: [{
                      match_phrase_prefix: {
                        [keyService$1.longKeyToShortKey('name')]: {
                          query: name,
                          max_expansions: 10,
                          slop: 10
                        }
                      }
                    }, {
                      match_phrase_prefix: {
                        [keyService$1.longKeyToShortKey('longName')]: {
                          query: name,
                          max_expansions: 10,
                          slop: 10
                        }
                      }
                    }]
                  }
                }]
              }
            },
            functions: [{
              gauss: {
                sdy: {
                  origin: DateTime.now().toFormat('yyyy-MM-dd'),
                  scale: '180d',
                  offset: '90d',
                  decay: 0.5
                }
              }
            }]
          }
        }
      };
      if (countryCodes && countryCodes.length > 0) {
        const countryCodeKey = keyService$1.longKeyToShortKey('countryCode');
        const should = countryCodes.map(countryCode => {
          return {
            match: {
              [countryCodeKey]: countryCode
            }
          };
        });
        const query = {
          bool: {
            should
          }
        };
        body.query.function_score.query.bool.must.push(query);
      }
      if (states && states.length > 0) {
        const should = states.map(state => {
          return {
            match: {
              [keyService$1.longKeyToShortKey('locationSearchArea')]: state
            }
          };
        });
        const query = {
          bool: {
            should
          }
        };
        body.query.function_score.query.bool.must.push(query);
      }
      return this.http.post(url, body).pipe(catchError(HttpHelperService.handleError)).pipe(map(data => {
        const meetList = [];
        if (data && data.hits) {
          Object.keys(data.hits.hits).forEach(idx => {
            const obj = keyService$1.shortToLong(data.hits.hits[idx]._source);
            const meet = obj;
            meetList.push(meet);
          });
        }
        return meetList;
      }));
    }
    getMediaItem(meetId, id) {
      return this.http.get(this.elasticEndpoint + '/media_items_' + meetId + '/_doc/' + id).pipe(map(data => {
        data = keyService$1.shortToLong(data._source);
        const obj = data;
        if (!obj.id) {
          obj.id = data._id;
        }
        return obj;
      }));
    }
    searchMediaItems(meetId, searchImages, searchVideos, context, from = 0, size = 100) {
      const searchQuery = {
        from,
        size,
        query: {
          bool: {
            must: []
          }
        }
      };
      const typeSearch = {};
      if (searchImages && !searchVideos) {
        typeSearch['term'] = {};
        typeSearch['term']['mediaType'] = 'image';
      } else if (!searchImages && searchVideos) {
        typeSearch['term'] = {};
        typeSearch['term']['mediaType'] = 'video';
      }
      if (typeSearch) {
        searchQuery.query.bool.must.push(typeSearch);
      }
      const sampleContext = {
        "roundIds": ["14-1"],
        "compNums": ["1", "2"]
      };
      Object.keys(context).forEach(fieldKey => {
        const contextSearch = {
          bool: {
            should: []
          }
        };
        context[fieldKey].forEach(value => {
          contextSearch.bool.should.push({
            match_phrase: {
              [fieldKey]: value
            }
          });
        });
        searchQuery.query.bool.must.push(contextSearch);
      });
      return this.http.post(this.elasticEndpoint + '/media_items_' + meetId + '/_search', searchQuery).pipe(map(data => {
        const records = [];
        let total = 0;
        if (data && data.hits) {
          if (data.hits.total && data.hits.total.value) {
            total = +data.hits.total.value;
          }
          Object.keys(data.hits.hits).forEach(idx => {
            const obj = keyService$1.shortToLong(data.hits.hits[idx]._source);
            const record = obj;
            if (!record.id) {
              record.id = data.hits.hits[idx]._id;
            }
            records.push(record);
          });
        }
        return {
          total,
          mediaItems: records
        };
      }));
    }
    search(searchIndex, searchString, meetId, functions) {
      let allowSearch = false;
      const nameSearch = {};
      const meetIdSearch = {};
      nameSearch[keyService$1.longKeyToShortKey('name')] = {
        query: searchString,
        max_expansions: 10,
        slop: 10
      };
      const searchQuery = {
        from: 0,
        size: 10,
        query: {
          bool: {}
        }
      };
      // If integer, we need to slightly tweak query to also look for comp #s
      if (/^(\d+)$/.test(searchString)) {
        searchQuery.query.bool.should = [];
        searchQuery.query.bool.should.push({
          match_phrase_prefix: nameSearch
        });
        searchQuery.query.bool.should.push({
          match: {
            nu: {
              query: searchString,
              boost: 5
            }
          }
        });
        searchQuery.query.bool.minimum_should_match = 1;
        allowSearch = true;
      } else {
        searchQuery.query.bool.must = {
          match_phrase_prefix: nameSearch
        };
        if (searchString.length >= 3) {
          allowSearch = true;
        }
      }
      if (searchIndex === 'search_record' && meetId) {
        meetIdSearch[keyService$1.longKeyToShortKey('meetId')] = meetId;
        searchQuery.query.bool.filter = {
          term: meetIdSearch
        };
      }
      if (allowSearch) {
        if (functions) {
          searchQuery.query = {
            function_score: {
              query: searchQuery.query,
              functions
            }
          };
        }
        return this.http.post(this.elasticEndpoint + '/' + searchIndex + '/_search', searchQuery).pipe(map(data => {
          const records = [];
          if (data && data.hits) {
            Object.keys(data.hits.hits).forEach(idx => {
              const obj = keyService$1.shortToLong(data.hits.hits[idx]._source);
              const record = obj;
              records.push(record);
            });
          }
          return records;
        }));
      } else {
        return of([]);
      }
    }
    /**
     *
     * @param searchIndex meet index to search
     * @param weekOffset offset from this week
     * @param startDate YYYY-MM-DDTHH:MM:SS
     * @param endDate YYYY-MM-DDTHH:MM:SS
     */
    getMeetsByDateRange(searchIndex, weekOffset, startDate, endDate) {
      const publishedSearch = {};
      publishedSearch[keyService$1.longKeyToShortKey('published')] = true;
      const dateRangeSearch = {};
      dateRangeSearch[keyService$1.longKeyToShortKey('date')] = {
        gt: startDate,
        lte: endDate
      };
      return this.http.post(this.elasticEndpoint + '/' + searchIndex + '_meet_list/_search', {
        size: 200,
        query: {
          bool: {
            must: [{
              term: publishedSearch
            }, {
              range: dateRangeSearch
            }]
          }
        }
      }, {}).pipe(catchError(HttpHelperService.handleError)).pipe(map(data => {
        const meetList = [];
        if (data && data.hits) {
          Object.keys(data.hits.hits).forEach(idx => {
            const obj = keyService$1.shortToLong(data.hits.hits[idx]._source);
            const meet = obj;
            meetList.push(meet);
          });
        }
        return meetList;
      }));
    }
    getMeetScoreReport(id) {
      return this.http.get(this.searchEndpoint + '/meet_score_report/_doc/' + id).pipe(map(data => {
        data = keyService$1.shortToLong(data._source);
        const obj = data;
        return obj;
      }));
    }
    getMeetScoreSpreadsheetReport(id) {
      return this.http.get(this.searchEndpoint + '/meet_score_spreadsheet_report/_doc/' + id).pipe(map(data => {
        data = keyService$1.shortToLong(data._source);
        const obj = data;
        return obj;
      }));
    }
    // public getPplFile(id: number): Observable<PplFile> {
    //   return this.http.get<PplFile>(this.searchEndpoint + "/ppl_file/_doc/" + id)
    //     .pipe(
    //       map((data: any) => {
    //         data = keyService.shortToLong(data._source);
    //         let obj: PplFile = data;
    //         return obj;
    //       })
    //     )
    // }
    getRecordReport(id) {
      return this.http.get(this.searchEndpoint + '/record_report/_doc/records|' + id).pipe(map(data => {
        data = keyService$1.shortToLong(data._source);
        const obj = data;
        return obj;
      }));
    }
    getRelayEntriesList(id) {
      return this.http.get(this.searchEndpoint + '/rel_ent_list/_doc/' + id).pipe(map(data => {
        data = keyService$1.shortToLong(data._source);
        const obj = data;
        return obj;
      }));
    }
    // public getRelayEventDetail(id: number): Observable<RelayEventDetail> {
    //   return this.http.get<RelayEventDetail>(this.searchEndpoint + "/relay_event_detail/_doc/" + id)
    //     .pipe(
    //       map((data: any) => {
    //         data = keyService.shortToLong(data._source);
    //         let obj: RelayEventDetail = data;
    //         return obj;
    //       })
    //     )
    // }
    //
    // public getRelayEventList(id: number): Observable<RelayEventList> {
    //   return this.http.get<RelayEventList>(this.searchEndpoint + "/relay_event_list/_doc/" + id)
    //     .pipe(
    //       map((data: any) => {
    //         data = keyService.shortToLong(data._source);
    //         let obj: RelayEventList = data;
    //         return obj;
    //       })
    //     )
    // }
    getRelayHeatsList(id) {
      return this.http.get(this.searchEndpoint + '/rel_heat_list/_doc/' + id).pipe(map(data => {
        data = keyService$1.shortToLong(data._source);
        const obj = data;
        return obj;
      }));
    }
    getRelayResultsList(id) {
      return this.http.get(this.searchEndpoint + '/rel_res_list/_doc/' + id).pipe(map(data => {
        data = keyService$1.shortToLong(data._source);
        const obj = data;
        return obj;
      }));
    }
    getRelayWinnersReport(id) {
      return this.http.get(this.searchEndpoint + '/relay_winners_report/_doc/winners' + id).pipe(map(data => {
        data = keyService$1.shortToLong(data._source);
        const obj = data;
        return obj;
      }));
    }
    getRelayRunSplitReport(id, heatNumber) {
      return this.http.get(this.searchEndpoint + '/run_split_report/_doc/RRSR|' + id + (heatNumber ? '-H' + heatNumber : '')).pipe(map(data => {
        data = keyService$1.shortToLong(data._source);
        const obj = data;
        return obj;
      }));
    }
    getSearchRecord(id) {
      return this.http.get(this.searchEndpoint + '/search_record/_doc/' + id).pipe(map(data => {
        data = keyService$1.shortToLong(data._source);
        const obj = data;
        return obj;
      }));
    }
    getSessionDetail(id) {
      return this.http.get(this.searchEndpoint + '/session_detail/_doc/' + id).pipe(map(data => {
        data = keyService$1.shortToLong(data._source);
        const obj = data;
        return obj;
      }));
    }
    getSessionList(id) {
      return this.http.get(this.searchEndpoint + '/session_list/_doc/' + id).pipe(map(data => {
        data = keyService$1.shortToLong(data._source);
        const obj = data;
        return obj;
      }));
    }
    // public getScoreboardAthlete(id: number): Observable<ScoreboardAthlete> {
    //   return this.http.get<ScoreboardAthlete>(this.searchEndpoint + "/scoreboard_athlete/_doc/" + id)
    //     .pipe(
    //       map((data: any) => {
    //         data = keyService.shortToLong(data._source);
    //         let obj: ScoreboardAthlete = data;
    //         return obj;
    //       })
    //     )
    // }
    //
    // public getScoreboardEvent(id: number): Observable<ScoreboardEvent> {
    //   return this.http.get<ScoreboardEvent>(this.searchEndpoint + "/scoreboard_event/_doc/" + id)
    //     .pipe(
    //       map((data: any) => {
    //         data = keyService.shortToLong(data._source);
    //         let obj: ScoreboardEvent = data;
    //         return obj;
    //       })
    //     )
    // }
    //
    // public getScoreboardMeet(id: number): Observable<ScoreboardMeet> {
    //   return this.http.get<ScoreboardMeet>(this.searchEndpoint + "/scoreboard_meet/_doc/" + id)
    //     .pipe(
    //       map((data: any) => {
    //         data = keyService.shortToLong(data._source);
    //         let obj: ScoreboardMeet = data;
    //         return obj;
    //       })
    //     )
    // }
    //
    // public getScoreboardTeamAbbr(id: number): Observable<ScoreboardTeamAbbr> {
    //   return this.http.get<ScoreboardTeamAbbr>(this.searchEndpoint + "/scoreboard_team_abbr/_doc/" + id)
    //     .pipe(
    //       map((data: any) => {
    //         data = keyService.shortToLong(data._source);
    //         let obj: ScoreboardTeamAbbr = data;
    //         return obj;
    //       })
    //     )
    // }
    //
    // public getScoreboardTeamFullName(id: number): Observable<ScoreboardTeamFullName> {
    //   return this.http.get<ScoreboardTeamFullName>(this.searchEndpoint + "/scoreboard_team_full_name/_doc/" + id)
    //     .pipe(
    //       map((data: any) => {
    //         data = keyService.shortToLong(data._source);
    //         let obj: ScoreboardTeamFullName = data;
    //         return obj;
    //       })
    //     )
    // }
    //
    // public getScoreboardTeamShortName(id: number): Observable<ScoreboardTeamShortName> {
    //   return this.http.get<ScoreboardTeamShortName>(this.searchEndpoint + "/scoreboard_team_short_name/_doc/" + id)
    //     .pipe(
    //       map((data: any) => {
    //         data = keyService.shortToLong(data._source);
    //         let obj: ScoreboardTeamShortName = data;
    //         return obj;
    //       })
    //     )
    // }
    getTeamDetail(id) {
      return this.http.get(this.searchEndpoint + '/team_detail/_doc/' + id).pipe(map(data => {
        data = keyService$1.shortToLong(data._source);
        const obj = data;
        return obj;
      }));
    }
    getTeamDetailByEvent(id) {
      return this.http.get(this.searchEndpoint + '/team_detail_by_event/_doc/' + id).pipe(map(data => {
        data = keyService$1.shortToLong(data._source);
        const obj = data;
        return obj;
      }));
    }
    getTeamList(meetId) {
      const query = {
        bool: {
          filter: {
            term: {}
          }
        }
      };
      query.bool.filter.term[keyService$1.longKeyToShortKey('meetId')] = meetId;
      return this.http.post(this.elasticEndpoint + '/team_list/_search', {
        from: 0,
        size: 2000,
        query
      }).pipe(catchError(HttpHelperService.handleError)).pipe(map(data => {
        const teamLists = [];
        if (data && data.hits) {
          Object.keys(data.hits.hits).forEach(idx => {
            const obj = keyService$1.shortToLong(data.hits.hits[idx]._source);
            const team = obj;
            teamLists.push(team);
          });
        }
        return teamLists;
      }));
    }
    getTimeStandardReport(id) {
      return this.http.get(this.searchEndpoint + '/time_standard_report/_doc/timeStandards|' + id).pipe(map(data => {
        data = keyService$1.shortToLong(data._source);
        const obj = data;
        return obj;
      }));
    }
    getIndividualWinnersReport(id) {
      return this.http.get(this.searchEndpoint + '/individual_winners_report/_doc/winners' + id).pipe(map(data => {
        data = keyService$1.shortToLong(data._source);
        const obj = data;
        return obj;
      }));
    }
    // public getWinMarginReport(id: number): Observable<WinMarginReport> {
    //   return this.http.get<WinMarginReport>(this.searchEndpoint + "/win_margin_report/_doc/" + id)
    //     .pipe(
    //       map((data: any) => {
    //         data = keyService.shortToLong(data._source);
    //         let obj: WinMarginReport = data;
    //         return obj;
    //       })
    //     )
    // }
    getVerticalSeriesReport(id) {
      return this.http.get(this.searchEndpoint + '/vertical_series_report/_doc/VSR|' + id).pipe(map(data => {
        data = keyService$1.shortToLong(data._source);
        const obj = data;
        return obj;
      }));
    }
    getXcScoreReport(id) {
      return this.http.get(this.searchEndpoint + '/xc_score_report/_doc/xcSR|' + id).pipe(map(data => {
        data = keyService$1.shortToLong(data._source);
        const obj = data;
        return obj;
      }));
    }
    getXcSplitScoreReport(id) {
      return this.http.get(this.searchEndpoint + '/xc_split_score_report/_doc/xcSSR|' + id).pipe(map(data => {
        data = keyService$1.shortToLong(data._source);
        const obj = data;
        return obj;
      }));
    }
    getXcTeamSummaryReport(individualEventId, teamId) {
      return this.http.get(this.searchEndpoint + '/xc_team_summary_report/_doc/xcTSR|' + individualEventId + '|' + teamId).pipe(map(data => {
        data = keyService$1.shortToLong(data._source);
        const obj = data;
        return obj;
      }));
    }
    getLiveResultsMeetList(id) {
      return this.http.get(this.searchEndpoint + '/live_results_meet_list/_doc/' + id).pipe(map(data => {
        data = keyService$1.shortToLong(data._source);
        const obj = data;
        return obj;
      }));
    }
    getTrackPointMvpReport(meetId) {
      return this.http.get(this.searchEndpoint + '/track_point_mvp_report/_doc/track_point_mvp_' + meetId).pipe(map(data => {
        data = keyService$1.shortToLong(data._source);
        const obj = data;
        return obj;
      }));
    }
    static {
      this.ɵfac = function AthleticLiveElasticApiService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AthleticLiveElasticApiService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AthleticLiveElasticApiService,
        factory: AthleticLiveElasticApiService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return AthleticLiveElasticApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const keyService = new KeyService();
let AthleticLiveFirebaseApiService = /*#__PURE__*/(() => {
  class AthleticLiveFirebaseApiService {
    constructor() {
      this.http = inject(HttpClient);
      this.db = inject(Database);
    }
    createObservableFromRef(dbRef) {
      return new Observable(observer => {
        const unsubscribe = onValue(dbRef, snapshot => {
          observer.next(snapshot.val());
        }, error => {
          observer.error(error);
        });
        return () => unsubscribe();
      });
    }
    createListObservableFromRef(dbRef) {
      return new Observable(observer => {
        const unsubscribe = onValue(dbRef, snapshot => {
          const data = snapshot.val();
          const result = [];
          if (data) {
            Object.keys(data).forEach(key => {
              result.push(data[key]);
            });
          }
          observer.next(result);
        }, error => {
          observer.error(error);
        });
        return () => unsubscribe();
      });
    }
    getAthleticSbBoard(boardId) {
      const dbRef = ref(this.db, 'athletic_sb/' + boardId);
      return this.createObservableFromRef(dbRef).pipe(map(data => {
        const obj = data;
        return obj;
      }));
    }
    getMeetLffs(meetId) {
      const dbRef = ref(this.db, 'meet_' + meetId + '/lff');
      return this.createObservableFromRef(dbRef);
    }
    getFullRaceVideoFiles(id, name = 'base') {
      const dbRef = ref(this.db, 'fullRaceVideoFiles/' + id + '/' + name);
      return this.createObservableFromRef(dbRef);
    }
    getBubbleTime(meetId) {
      const dbRef = ref(this.db, 'bubbleTime/' + meetId);
      return this.createObservableFromRef(dbRef);
    }
    getMeetBubbleTime(meetId) {
      const dbRef = ref(this.db, 'meet_' + meetId + '/bubbleTime/');
      return this.createObservableFromRef(dbRef);
    }
    getByFlightStandings(meetId, flightId) {
      const dbRef = ref(this.db, 'meet_' + meetId + '/byFlightStandings/' + flightId);
      return this.createObservableFromRef(dbRef).pipe(map(data => {
        data = keyService.shortToLong(data);
        const obj = data;
        return obj;
      }));
    }
    getByHeatResults(meetId, heatId) {
      const dbRef = ref(this.db, 'meet_' + meetId + '/byHeatResults/' + heatId);
      return this.createObservableFromRef(dbRef).pipe(map(data => {
        data = keyService.shortToLong(data);
        const obj = data;
        return obj;
      }));
    }
    getByHeatResultsArray(meetId, roundId) {
      const dbRef = ref(this.db, 'meet_' + meetId + '/byHeatResults/' + roundId);
      return this.createObservableFromRef(dbRef).pipe(map(data => {
        const standings = [];
        if (data) {
          Object.keys(data).forEach(resultId => {
            const obj = keyService.shortToLong(data[resultId]);
            const item = obj;
            standings.push(item);
          });
        }
        return standings.sort((a, b) => {
          const aPlace = +a.resultOrder;
          const bPlace = +b.resultOrder;
          if (isNaN(aPlace) && isNaN(bPlace)) {
            return 0;
          } else if (isNaN(aPlace)) {
            return 1;
          } else if (isNaN(bPlace)) {
            return -1;
          } else {
            return aPlace < bPlace ? -1 : 1;
          }
        });
      }));
    }
    getByRoundResults(meetId, roundId) {
      const dbRef = ref(this.db, 'meet_' + meetId + '/byRoundResults/' + roundId);
      return this.createObservableFromRef(dbRef).pipe(map(data => {
        data = keyService.shortToLong(data);
        const obj = data;
        return obj;
      }));
    }
    getByRoundResultsArray(meetId, roundId) {
      const dbRef = ref(this.db, 'meet_' + meetId + '/byRoundResults/' + roundId);
      return this.createObservableFromRef(dbRef).pipe(map(data => {
        const standings = [];
        if (data) {
          Object.keys(data).forEach(resultId => {
            const obj = keyService.shortToLong(data[resultId]);
            const item = obj;
            standings.push(item);
          });
        }
        return standings.sort((a, b) => {
          const aPlace = +a.place;
          const bPlace = +b.place;
          if (isNaN(aPlace) && isNaN(bPlace)) {
            return 0;
          } else if (isNaN(aPlace)) {
            return 1;
          } else if (isNaN(bPlace)) {
            return -1;
          } else {
            return aPlace < bPlace ? -1 : 1;
          }
        });
      }));
    }
    getLiveXcCompiledStandings(meetId, roundId) {
      const dbRef = ref(this.db, 'meet_' + meetId + '/liveRunStandings/' + roundId);
      return this.createObservableFromRef(dbRef).pipe(map(data => {
        data = keyService.shortToLong(data);
        const obj = data;
        return obj;
      }));
    }
    getLiveXcCompiledTeamStandings(meetId, roundId) {
      const dbRef = ref(this.db, 'meet_' + meetId + '/liveRunTeamStandings/' + roundId);
      return this.createObservableFromRef(dbRef).pipe(map(data => {
        data = keyService.shortToLong(data);
        const obj = data;
        return obj;
      }));
    }
    getLiveTeam(meetId, roundId, teamId) {
      const dbRef = ref(this.db, 'meet_' + meetId + '/liveTeam/' + roundId + '/' + teamId);
      return this.createObservableFromRef(dbRef).pipe(map(data => {
        data = keyService.shortToLong(data);
        const obj = data;
        return obj;
      }));
    }
    getIndEventDetail(meetId, eventId) {
      const dbRef = ref(this.db, 'meet_' + meetId + '/event_detail/Individual-' + eventId);
      return this.createObservableFromRef(dbRef).pipe(map(data => {
        data = keyService.shortToLong(data);
        const obj = data;
        return obj;
      }));
    }
    getRelEventDetail(meetId, eventId) {
      const dbRef = ref(this.db, 'meet_' + meetId + '/event_detail/Relay-' + eventId);
      return this.createObservableFromRef(dbRef).pipe(map(data => {
        data = keyService.shortToLong(data);
        const obj = data;
        return obj;
      }));
    }
    getCheckInEvents(meetId) {
      const dbRef = ref(this.db, 'meet_' + meetId + '/check_in');
      return this.createObservableFromRef(dbRef).pipe(map(data => {
        data = keyService.shortToLong(data);
        const obj = data;
        return obj;
      }));
    }
    getLiveStartTimes(meetId, roundId) {
      const dbRef = ref(this.db, 'meet_' + meetId + '/liveStartTimes/' + roundId);
      return this.createObservableFromRef(dbRef).pipe(map(data => {
        data = keyService.shortToLong(data);
        const obj = data;
        return obj;
      }));
    }
    getLiveStartTimeEntries(meetId, roundId) {
      const dbRef = ref(this.db, 'meet_' + meetId + '/liveByStartTime/' + roundId);
      return this.createObservableFromRef(dbRef).pipe(map(data => {
        data = keyService.shortToLong(data);
        const obj = data;
        return obj;
      }));
    }
    getComEventDetail(meetId, eventId) {
      const dbRef = ref(this.db, 'meet_' + meetId + '/event_detail/Combined-' + eventId);
      return this.createObservableFromRef(dbRef).pipe(map(data => {
        data = keyService.shortToLong(data);
        const obj = data;
        return obj;
      }));
    }
    getMeetEventSummary(meetId) {
      const dbRef = ref(this.db, 'meet_' + meetId + '/event_summary');
      return this.createObservableFromRef(dbRef).pipe(map(data => {
        data = keyService.shortToLong(data);
        const obj = data;
        return obj;
      }));
    }
    getEventSummary(meetId, eventId) {
      const dbRef = ref(this.db, 'meet_' + meetId + '/event_summary/' + eventId);
      return this.createObservableFromRef(dbRef).pipe(map(data => {
        data = keyService.shortToLong(data);
        const obj = data;
        return obj;
      }));
    }
    getIndEventSummary(meetId, eventId) {
      const dbRef = ref(this.db, 'meet_' + meetId + '/event_summary/Individual-' + eventId);
      return this.createObservableFromRef(dbRef).pipe(map(data => {
        data = keyService.shortToLong(data);
        const obj = data;
        return obj;
      }));
    }
    getRelEventSummary(meetId, eventId) {
      const dbRef = ref(this.db, 'meet_' + meetId + '/event_summary/Relay-' + eventId);
      return this.createObservableFromRef(dbRef).pipe(map(data => {
        data = keyService.shortToLong(data);
        const obj = data;
        return obj;
      }));
    }
    getLatestUpdates(meetId) {
      const dbRef = ref(this.db, 'latest_update_list/' + meetId);
      return this.createObservableFromRef(dbRef).pipe(map(data => {
        data = keyService.shortToLong(data);
        const obj = data;
        return obj;
      }));
    }
    getMeetList(id) {
      const dbRef = ref(this.db, 'meet_list/' + id);
      return this.createObservableFromRef(dbRef).pipe(map(data => {
        data = keyService.shortToLong(data);
        const obj = data;
        return obj;
      }));
    }
    getMeetScoreReport(meetId, id) {
      const dbRef = ref(this.db, 'meet_' + meetId + '/meet_score_report/' + id);
      return this.createObservableFromRef(dbRef).pipe(map(data => {
        if (data) {
          data = keyService.shortToLong(data);
          const obj = data;
          return obj;
        }
        return null;
      }));
    }
    getLiveCombinedEvent(meetId, eventId) {
      const dbRef = ref(this.db, 'meet_' + meetId + '/combinedTable/' + eventId);
      return this.createObservableFromRef(dbRef).pipe(map(data => {
        data = keyService.shortToLong(data);
        const obj = data;
        return obj;
      }));
    }
    getLiveFieldEvent(meetId, roundId) {
      const dbRef = ref(this.db, 'meet_' + meetId + '/liveFieldEvents/' + roundId);
      return this.createObservableFromRef(dbRef).pipe(map(data => {
        data = keyService.shortToLong(data);
        const obj = data;
        return obj;
      }));
    }
    getMeetLiveFieldEvents(meetId) {
      const dbRef = ref(this.db, 'meet_' + meetId + '/liveFieldEvents');
      return this.createObservableFromRef(dbRef).pipe(map(data => {
        data = keyService.shortToLong(data);
        const obj = data;
        return obj;
      }));
    }
    getPublishedMeetLiveFieldEvents(meetId) {
      const dbRef = query(ref(this.db, 'meet_' + meetId + '/liveFieldEvents'), orderByChild(keyService.longKeyToShortKey('published')), equalTo(true));
      return this.createListObservableFromRef(dbRef).pipe(map(data => {
        data.forEach((item, idx) => {
          data[idx] = keyService.shortToLong(item);
        });
        const obj = data;
        return obj;
      }));
    }
    getLiveFieldEvents(meetId) {
      const dbRef = query(ref(this.db, 'meet_' + meetId + '/liveFieldEvents'), orderByChild(keyService.longKeyToShortKey('isLive')), equalTo(true));
      return this.createListObservableFromRef(dbRef).pipe(map(data => {
        data.forEach((item, idx) => {
          data[idx] = keyService.shortToLong(item);
        });
        const obj = data;
        return obj;
      }));
    }
    getLiveRunHeats(meetId) {
      const dbRef = ref(this.db, 'meet_' + meetId + '/liveRunHeat/');
      return this.createObservableFromRef(dbRef).pipe(map(data => {
        data = keyService.shortToLong(data);
        const obj = data;
        return obj;
      }));
    }
    getLiveRunHeat(meetId, scoreboardId) {
      const dbRef = ref(this.db, 'meet_' + meetId + '/liveRunHeat/' + scoreboardId);
      return this.createObservableFromRef(dbRef).pipe(map(data => {
        data = keyService.shortToLong(data);
        const obj = data;
        return obj;
      }));
    }
    /**
     * For track, we always know that the scoreboards are track and track2.
     * xc is different, but hopefully we can fix that soon.
     */
    getLiveRunEvent(meetId, scoreboardId) {
      const dbRef = ref(this.db, 'meet_' + meetId + '/liveRunEvent/' + scoreboardId);
      return this.createObservableFromRef(dbRef).pipe(map(data => {
        data = keyService.shortToLong(data);
        const obj = this.mapXcSplitObjectToArray(data);
        return obj;
      }));
    }
    /**
     * Retrieve running time only for this scoreboard
     */
    getLiveRunEventRunningTime(meetId, scoreboardId) {
      const dbRef = ref(this.db, 'meet_' + meetId + '/liveRunEvent/' + scoreboardId + '/runTime');
      return this.createObservableFromRef(dbRef);
    }
    /**
     * a live run event without running time
     */
    getRawLiveRunEvent(meetId, scoreboardId) {
      const dbRef = ref(this.db, 'meet_' + meetId + '/rawLiveRunEvent/' + scoreboardId);
      return this.createObservableFromRef(dbRef).pipe(map(data => {
        data = keyService.shortToLong(data);
        const obj = this.mapXcSplitObjectToArray(data);
        return obj;
      }));
    }
    mapXcSplitObjectToArray(liveRunEvent) {
      if (liveRunEvent.split && !liveRunEvent.splits) {
        liveRunEvent.splits = [];
        Object.keys(liveRunEvent.split).forEach(splitKey => {
          liveRunEvent.splits.push(liveRunEvent.split[splitKey]);
        });
      }
      return liveRunEvent;
    }
    /**
     * roundId = eventNumber-roundNumber
     */
    getLiveEventByRoundId(meetId, roundId) {
      const dbRef = ref(this.db, 'meet_' + meetId + '/liveRunEventList/' + roundId);
      return this.createObservableFromRef(dbRef).pipe(map(data => {
        data = keyService.shortToLong(data);
        const obj = data;
        return obj;
      }));
    }
    /**
     * roundId = eventNumber-roundNumber
     */
    getLiveRunEventByRoundId(meetId, roundId) {
      const dbRef = ref(this.db, 'meet_' + meetId + '/liveRunEventList/' + roundId);
      return this.createObservableFromRef(dbRef).pipe(map(data => {
        data = keyService.shortToLong(data);
        const obj = this.mapXcSplitObjectToArray(data);
        return obj;
      }));
    }
    /**
     * Convert from object to array here
     */
    getLiveRunEvents(meetId) {
      const dbRef = ref(this.db, 'meet_' + meetId + '/liveRunEvent/');
      return this.createObservableFromRef(dbRef).pipe(map(data => {
        const arr = [];
        if (data) {
          Object.keys(data).forEach(key => {
            if ('rui' in data[key] && data[key].rui !== '0-0') {
              data[key] = keyService.shortToLong(data[key]);
              const obj = this.mapXcSplitObjectToArray(data[key]);
              arr.push(obj);
            }
          });
        }
        const obj = arr;
        return obj;
      }));
    }
    getLiveRunEventRuntime(meetId, scoreboardId) {
      const dbRef = ref(this.db, 'meet_' + meetId + '/liveRunEvent/' + scoreboardId + '/runTime');
      return this.createObservableFromRef(dbRef).pipe(map(data => {
        return data;
      }));
    }
    getLiveXcResultsBySplit(meetId, roundId, split) {
      const dbRef = ref(this.db, 'meet_' + meetId + '/liveBySplit/results/' + roundId + '/' + split);
      return this.createObservableFromRef(dbRef).pipe(map(data => {
        data = keyService.shortToLong(data);
        const obj = data;
        return obj;
      }));
    }
    getLiveXcTeamResultsBySplit(meetId, roundId, split, gender = '') {
      const dbRef = ref(this.db, 'meet_' + meetId + '/liveBySplit/teamResults' + gender + '/' + roundId + '/' + split);
      return this.createObservableFromRef(dbRef).pipe(map(data => {
        data = keyService.shortToLong(data);
        const obj = data;
        return obj;
      }));
    }
    getLiveHorizontalFieldStandings(meetId, roundId) {
      const dbRef = ref(this.db, 'meet_' + meetId + '/liveFieldStandings/' + roundId);
      return this.createObservableFromRef(dbRef).pipe(map(data => {
        data = keyService.shortToLong(data);
        const obj = data;
        return obj;
      }));
    }
    getLiveHorizontalFieldStandingsArray(meetId, standingsType, roundId, flightId = null, isFinalFlight = false) {
      const path = 'meet_' + meetId + '/liveFieldStandings/' + roundId;
      const dbRef = ref(this.db, path);
      return this.createObservableFromRef(dbRef).pipe(map(data => {
        const standings = [];
        if (data) {
          Object.keys(data).forEach(athleteId => {
            const obj = keyService.shortToLong(data[athleteId]);
            const item = obj;
            standings.push(item);
          });
        }
        return standings.filter(result => {
          if (standingsType === 'flight') {
            if (isFinalFlight) {
              return result.isFinal === true;
            } else {
              return result.heat === flightId;
            }
          } else {
            return true;
          }
        }).sort((a, b) => {
          let aPlace = +a.place;
          let bPlace = +b.place;
          if (standingsType === 'flight') {
            if (isFinalFlight) {
              aPlace = +a.finalPosition;
              bPlace = +b.finalPosition;
            } else {
              aPlace = +a.resultOrder;
              bPlace = +b.resultOrder;
            }
          }
          if (standingsType === 'round') {
            if (a.bestMark.mark === 'DNS') {
              aPlace = 10000020;
            }
            if (b.bestMark.mark === 'DNS') {
              bPlace = 10000020;
            }
            if (isNaN(aPlace)) {
              aPlace = 10000010;
            }
            if (isNaN(bPlace)) {
              bPlace = 10000010;
            }
            if (a.bestMark.mark === 'NM') {
              aPlace = 10000005;
            }
            if (b.bestMark.mark === 'NM') {
              bPlace = 10000005;
            }
          }
          if (isNaN(aPlace) && isNaN(bPlace)) {
            return 0;
          } else if (isNaN(aPlace)) {
            return 1;
          } else if (isNaN(bPlace)) {
            return -1;
          } else {
            return aPlace < bPlace ? -1 : 1;
          }
        });
      }));
    }
    getLiveVerticalFieldStandings(meetId, roundId) {
      const dbRef = ref(this.db, 'meet_' + meetId + '/liveFieldStandings/' + roundId);
      return this.createObservableFromRef(dbRef).pipe(map(data => {
        data = keyService.shortToLong(data);
        const obj = data;
        return obj;
      }));
    }
    getLiveVerticalFieldStandingsArray(meetId, standingsType, roundId, flightId = null) {
      const path = 'meet_' + meetId + '/liveFieldStandings/' + roundId;
      const dbRef = ref(this.db, path);
      return this.createObservableFromRef(dbRef).pipe(map(data => {
        const standings = [];
        if (data) {
          Object.keys(data).forEach(athleteId => {
            const obj = keyService.shortToLong(data[athleteId]);
            const item = obj;
            standings.push(item);
          });
        }
        return standings.filter(result => {
          if (standingsType === 'flight') {
            return result.heat === flightId;
          } else {
            return true;
          }
        }).sort((a, b) => {
          let aPlace = +a.place;
          let bPlace = +b.place;
          // For standings type round, Sort NH, DNS, nothing
          if (standingsType === 'flight') {
            aPlace = +a.resultOrder;
            bPlace = +b.resultOrder;
          }
          if (standingsType === 'round') {
            if (a.bestMark.height === 'NH') {
              aPlace = 10000010;
            }
            if (b.bestMark.height === 'NH') {
              bPlace = 10000010;
            }
            if (isNaN(aPlace)) {
              aPlace = 10000020;
            }
            if (isNaN(bPlace)) {
              bPlace = 10000020;
            }
          }
          if (isNaN(aPlace) && isNaN(bPlace)) {
            return 0;
          } else if (isNaN(aPlace)) {
            return 1;
          } else if (isNaN(bPlace)) {
            return -1;
          } else {
            return aPlace < bPlace ? -1 : 1;
          }
        });
      }));
    }
    getHeatSplitGridSet(meetId, heatId) {
      const dbRef = ref(this.db, 'meet_' + meetId + '/splitGrids/' + heatId);
      return this.createObservableFromRef(dbRef).pipe(map(data => {
        data = keyService.shortToLong(data);
        const obj = data;
        return obj;
      }));
    }
    getHeatSplitGridAthletesGrid(meetId, heatId, gridIdx) {
      const dbRef = ref(this.db, 'meet_' + meetId + '/splitGridAthletes/' + heatId + '/' + gridIdx);
      return this.createListObservableFromRef(dbRef).pipe(map(data => {
        const standings = [];
        if (data) {
          Object.keys(data).forEach(resultId => {
            const obj = keyService.shortToLong(data[resultId]);
            const item = obj;
            standings.push(item);
          });
        }
        return standings.sort((a, b) => {
          // latest split laps to go
          // latest split place
          // lane
          let aLastSplit;
          let bLastSplit;
          // compare their last
          for (let sgaIdx = 0; sgaIdx < a.splitGridAthleteSplits.length; sgaIdx++) {
            if (a.splitGridAthleteSplits[sgaIdx].integerMark || sgaIdx === a.splitGridAthleteSplits.length - 1) {
              aLastSplit = a.splitGridAthleteSplits[sgaIdx];
              break;
            }
          }
          for (let sgaIdx = 0; sgaIdx < b.splitGridAthleteSplits.length; sgaIdx++) {
            if (b.splitGridAthleteSplits[sgaIdx].integerMark || sgaIdx === b.splitGridAthleteSplits.length - 1) {
              bLastSplit = b.splitGridAthleteSplits[sgaIdx];
              break;
            }
          }
          const isALastSplit = +aLastSplit.integerMark > 0;
          const isBLastSplit = +bLastSplit.integerMark > 0;
          if (!isALastSplit && !isBLastSplit) {
            const aLane = +a.lane;
            const bLane = +b.lane;
            return this.compareNumbers(aLane, bLane);
          }
          if (!isALastSplit && isBLastSplit) {
            return 1;
          }
          if (isALastSplit && !isBLastSplit) {
            return -1;
          }
          // on the same split
          if (aLastSplit.number && bLastSplit.number) {
            const aSplitNumber = +aLastSplit.number;
            const bSplitNumber = +bLastSplit.number;
            if (aSplitNumber > bSplitNumber) {
              return -1;
            }
            if (aSplitNumber < bSplitNumber) {
              return 1;
            }
            return this.compareNumbers(aLastSplit.place, bLastSplit.place);
          }
        });
      }));
    }
    compareNumbers(a, b, order = 'asc') {
      const aNum = +a;
      const bNum = +b;
      if (isNaN(aNum) && isNaN(bNum)) {
        return 0;
      } else if (isNaN(aNum)) {
        return 1;
      } else if (isNaN(bNum)) {
        return -1;
      } else if (a === '' && b === '') {
        return 0;
      } else if (a === '') {
        return 1;
      } else if (b === '') {
        return -1;
      } else {
        if (order === 'asc') {
          return aNum < bNum ? -1 : 1;
        } else if (order === 'desc') {
          return aNum > bNum ? -1 : 1;
        }
      }
    }
    getLiveHorizontalFieldSummary(meetId, scoreboardId) {
      const dbRef = ref(this.db, 'meet_' + meetId + '/liveFieldResults/' + scoreboardId);
      return this.createObservableFromRef(dbRef).pipe(map(data => {
        data = keyService.shortToLong(data);
        const obj = data;
        const upNowAthleteIds = [];
        if ('competitionArea' in data) {
          Object.keys(data.competitionArea).forEach(competitionAreaId => {
            if ('upNow' in data.competitionArea[competitionAreaId] && 'id' in data.competitionArea[competitionAreaId].upNow) {
              upNowAthleteIds.push(data.competitionArea[competitionAreaId].upNow.id);
            }
          });
        }
        obj.upNowAthleteIds = upNowAthleteIds;
        return obj;
      }));
    }
    getLiveVerticalFieldSummary(meetId, scoreboardId) {
      const dbRef = ref(this.db, 'meet_' + meetId + '/liveFieldResults/' + scoreboardId);
      return this.createObservableFromRef(dbRef).pipe(map(data => {
        data = keyService.shortToLong(data);
        const obj = data;
        const upNowAthleteIds = [];
        if ('competitionArea' in data) {
          Object.keys(data.competitionArea).forEach(competitionAreaId => {
            if ('upNow' in data.competitionArea[competitionAreaId] && 'id' in data.competitionArea[competitionAreaId].upNow) {
              upNowAthleteIds.push(data.competitionArea[competitionAreaId].upNow.id);
            }
          });
        }
        obj.upNowAthleteIds = upNowAthleteIds;
        return obj;
      }));
    }
    getLiveSummaries(meetId) {
      const liveFieldResultsRef = query(ref(this.db, 'meet_' + meetId + '/liveFieldResults'), orderByChild(keyService.longKeyToShortKey('event') + '/' + keyService.longKeyToShortKey('isLive')), equalTo(true));
      const rawLiveRunEventRef = ref(this.db, 'meet_' + meetId + '/rawLiveRunEvent');
      const liveRunHeatRef = ref(this.db, 'meet_' + meetId + '/liveRunHeat');
      return combineLatest([this.createListObservableFromRef(liveFieldResultsRef), this.createObservableFromRef(rawLiveRunEventRef), this.createObservableFromRef(liveRunHeatRef)]).pipe(map(([liveFieldEventArr, liveRunEventObj, liveRunHeatObj]) => {
        const obj = {
          vertical: [],
          horizontal: [],
          track: []
        };
        if (liveFieldEventArr) {
          liveFieldEventArr.forEach(liveFieldEvent => {
            const data = keyService.shortToLong(liveFieldEvent);
            if (data.event.fieldEventOrientation === 'Vertical') {
              const summary = data;
              summary.upNowAthleteIds = [];
              const compAreas = [];
              if (summary.competitionArea) {
                Object.keys(summary.competitionArea).forEach(key => {
                  summary.competitionArea[key].id = key;
                  compAreas.push(summary.competitionArea[key]);
                  if (summary.competitionArea[key] && summary.competitionArea[key].upNow) {
                    summary.upNowAthleteIds.push(summary.competitionArea[key].upNow.id);
                  }
                });
              }
              summary.competitionAreas = compAreas;
              obj.vertical.push(summary);
            } else if (data.event.fieldEventOrientation === 'Horizontal') {
              const summary = data;
              summary.upNowAthleteIds = [];
              const compAreas = [];
              if (summary.competitionArea) {
                Object.keys(summary.competitionArea).forEach(key => {
                  summary.competitionArea[key].id = key;
                  compAreas.push(summary.competitionArea[key]);
                  if (summary.competitionArea[key] && summary.competitionArea[key].upNow) {
                    summary.upNowAthleteIds.push(summary.competitionArea[key].upNow.id);
                  }
                });
              }
              summary.competitionAreas = compAreas;
              obj.horizontal.push(summary);
            }
          });
        }
        if (liveRunEventObj) {
          Object.keys(liveRunEventObj).forEach(key => {
            if ('rui' in liveRunEventObj[key] && liveRunEventObj[key].rui !== '0-0') {
              const data = keyService.shortToLong(liveRunEventObj[key]);
              const eventObj = data;
              let heatObj;
              if (liveRunHeatObj && key in liveRunHeatObj) {
                const heat = keyService.shortToLong(liveRunHeatObj[key]);
                heatObj = heat;
                if (heatObj.results) {
                  heatObj.resultsArray = Object.values(heatObj.results).sort((a, b) => {
                    const aSortItem = a.resultOrder;
                    const bSortItem = b.resultOrder;
                    if (aSortItem === null && bSortItem === null) {
                      return 0;
                    } else if (aSortItem === null) {
                      return 1;
                    } else if (bSortItem === null) {
                      return -1;
                    }
                    return aSortItem < bSortItem ? -1 : 1;
                  });
                }
              } else {
                heatObj = {
                  entries: null,
                  results: null,
                  splitGrids: null,
                  resultsArray: []
                };
              }
              obj.track.push({
                event: eventObj,
                heat: heatObj
              });
            }
          });
        }
        return obj;
      }));
    }
    static {
      this.ɵfac = function AthleticLiveFirebaseApiService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AthleticLiveFirebaseApiService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AthleticLiveFirebaseApiService,
        factory: AthleticLiveFirebaseApiService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return AthleticLiveFirebaseApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SetDataOptionsService = /*#__PURE__*/(() => {
  class SetDataOptionsService {
    constructor(aliveFirebaseService, elasticApiService) {
      this.aliveFirebaseService = aliveFirebaseService;
      this.elasticApiService = elasticApiService;
      this.isXcMeet = false;
      this.compiledResultOptions = [];
      this.heatsByEvent = {};
      this.teamsByEvent = {};
      this.xcSummaryRaces = [];
      this.xcSummaryOptionsByEvent = {};
      this.fieldSelectOptions = [];
      this.athleticFieldDeviceNames = [];
      this.fieldCompetitionAreasByEvent = {};
      this.fieldAthletesByEvent = {};
      this.meetId = +(window.localStorage.getItem('asbCurrentMeetId') ?? '');
      this.athleticFieldDeviceNames = window.localStorage.getItem('asbFieldDeviceNames')?.split(',') ?? [];
      window.addEventListener('storage', event => {
        if (event.storageArea === localStorage && event.key === 'asbCurrentMeetId' && event.oldValue !== event.newValue) {
          this.meetId = +(window.localStorage.getItem('asbCurrentMeetId') ?? '');
          this.updateMeetId();
          console.log('updated meet id to:', this.meetId);
        }
        if (event.storageArea === localStorage && event.key === 'asbFieldDeviceNames') {
          this.updateAthleticFieldDeviceNames();
        }
      });
      // fire whenever meetId or field device names are updated
      /* const storageEvent = new StorageEvent('storage', {
        key: 'asbCurrentMeetId',
        oldValue: oldMeetId,
        newValue: newMeetId,
        storageArea: localStorage,
      });
      window.dispatchEvent(storageEvent); */
      this.updateMeetId();
      this.updateAthleticFieldDeviceNames();
    }
    ngOnDestroy() {
      this.meetListSubscription.unsubscribe();
      this.eventSummariesSubscription.unsubscribe();
    }
    updateMeetId() {
      this.clearOptions();
      this.updateAthleticFieldDeviceNames();
      // Meet List Subscription
      if (this.meetListSubscription) {
        this.meetListSubscription.unsubscribe();
        delete this.meetListSubscription;
      }
      this.meetListSubscription = this.aliveFirebaseService.getMeetList(this.meetId).pipe(catchError$1(val => of(val)), retry(2)).subscribe(data => {
        this.meetList = data;
        console.log('GETTING A MEET LIST:', data);
        if (data.sport && data.sport.toLowerCase() === 'xc') {
          this.isXcMeet = true;
          this.getXcSummaryOptions();
        } else {
          // track meet field options
          this.isXcMeet = false;
        }
      });
      // Event Summaries Subscription
      if (this.eventSummariesSubscription) {
        this.eventSummariesSubscription.unsubscribe();
        delete this.eventSummariesSubscription;
      }
      this.eventSummariesSubscription = this.aliveFirebaseService.getMeetEventSummary(this.meetId).pipe(map$1(meetEventSummary => {
        const eventSummaries = [];
        Object.keys(meetEventSummary).forEach(key => {
          if ('name' in meetEventSummary[key]) {
            // Only push if the meetEventSummary[key].name is valid
            eventSummaries.push(meetEventSummary[key]);
          }
        });
        eventSummaries.sort((a, b) => {
          return a.name.localeCompare(b.name) < 0 ? -1 : 1;
        });
        return eventSummaries;
      }), catchError$1(val => of(val)), retry(2)).subscribe(eventSummaries => {
        this.eventSummaries = eventSummaries;
        console.log('GETTING SOME EVENT SUMMARIES:', eventSummaries);
        this.getCompiledResultOptions();
        this.getFieldResultOptions();
      });
    }
    clearOptions() {
      this.compiledResultOptions = [];
      this.heatsByEvent = {};
      this.teamsByEvent = {};
      this.xcSummaryRaces = [];
      this.xcSummaryOptionsByEvent = {};
      this.fieldSelectOptions = [];
      this.athleticFieldDeviceNames = [];
      this.fieldCompetitionAreasByEvent = {};
      this.fieldAthletesByEvent = {};
    }
    getCompiledResultOptions() {
      const compiledResultOptions = [];
      const compiledHeatOptions = {};
      if (this.eventSummaries) {
        this.eventSummaries.forEach(event => {
          const compiledValue = event.eventCategory + '-' + event.id + '|||' + event.name;
          const compiledLabel = '#' + (event.number ?? event.roundId) + ') ' + event.name;
          compiledResultOptions.push({
            value: compiledValue,
            label: compiledLabel
          });
          if (event.hasHeats) {
            compiledHeatOptions[compiledValue] = [];
            if (Object.keys(event).includes('numHeats')) {
              if (event.numHeats && event.numHeats >= 1) {
                const heatArray = Array.from({
                  length: event.numHeats
                }, (_, i) => i + 1);
                compiledHeatOptions[compiledValue] = heatArray.map(val => {
                  return {
                    label: 'Heat ' + val,
                    value: val.toString()
                  };
                });
              }
            }
          }
        });
      }
      this.compiledResultOptions = compiledResultOptions;
      this.heatsByEvent = compiledHeatOptions;
      console.log(compiledHeatOptions);
    }
    async updateTeamsForEvent(documentId) {
      if (documentId) {
        const eventId = +documentId.toString().split('|||')[0].split('-')[1];
        // Get the event entries
        const event = await firstValueFrom(this.elasticApiService.getIndividualEntriesList(eventId));
        if (!event || !event.individualEntries) {
          return;
        }
        // Get the teams
        const teams = event.individualEntries.map(entry => {
          return {
            value: entry.athlete.team.id,
            label: entry.athlete.team.fullName
          };
        }).filter((team, index, self) => {
          return index === self.findIndex(t => t.value === team.value);
        }).sort((a, b) => a.label.localeCompare(b.label));
        const eventKey = event.eventCategory + '-' + event.id + '|||' + event.name;
        this.teamsByEvent[eventKey] = [{
          value: 'all',
          label: 'All Teams'
        }];
        this.teamsByEvent[eventKey].push(...teams);
        if (this.teamsByEvent[eventKey].length <= 1) {
          delete this.teamsByEvent[eventKey];
        }
      }
    }
    async updateAthletesForEvent(documentId) {
      if (documentId) {
        const roundId = documentId.split('|||')[0] ?? '';
        if (roundId) {
          // Get the event entries
          const event = await firstValueFrom(this.aliveFirebaseService.getLiveFieldEvent(this.meetId, roundId).pipe(filter(event => 'fieldEventOrientation' in event), switchMap(event => {
            if (event.fieldEventOrientation === 'Horizontal') {
              return this.aliveFirebaseService.getLiveHorizontalFieldSummary(this.meetId, roundId);
            } else if (event.fieldEventOrientation === 'Vertical') {
              return this.aliveFirebaseService.getLiveVerticalFieldSummary(this.meetId, roundId);
            } else {
              // shouldn't ever run, but gets rid of typing error
              return this.aliveFirebaseService.getLiveHorizontalFieldSummary(this.meetId, roundId);
            }
          })));
          if (!event || !event.standings) {
            return;
          }
          // Get the athletes
          const athletes = event.standings.map(entry => {
            const label = entry.name + (entry.id ? ' #' + entry.id + '' : '');
            return {
              value: entry.id + '|||' + label,
              label: label
            };
          }).sort((a, b) => a.label.localeCompare(b.label));
          this.fieldAthletesByEvent[documentId] = [];
          this.fieldAthletesByEvent[documentId].push(...athletes);
          if (this.fieldAthletesByEvent[documentId].length <= 1) {
            delete this.fieldAthletesByEvent[documentId];
          }
        }
      }
    }
    getXcSummaryOptions() {
      this.xcSummaryRaces = [];
      const xcSummaryOptions = [];
      const xcSummaryLiveOptions = [];
      const xcSummarySplitOptions = [];
      if (this.meetList.xcEventSplits && this.meetList.xcEventSplits.length > 0) {
        this.meetList.xcEventSplits.forEach(eventSplit => {
          if (this.xcSummaryRaces.findIndex(val => val.value === eventSplit.id) === -1) {
            this.xcSummaryRaces.push({
              value: eventSplit.id,
              label: '#' + eventSplit.eventNumber + ') ' + eventSplit.name
            });
          }
          if (eventSplit.isFinal) {
            xcSummaryLiveOptions.push({
              value: eventSplit.id + '|||' + eventSplit.name + ' - Live|||live=true',
              label: '#' + eventSplit.eventNumber + ') ' + eventSplit.name + ' - Live'
            });
          }
        });
        this.xcSummaryRaces.sort((a, b) => {
          return a.label.localeCompare(b.label, undefined, {
            numeric: true,
            sensitivity: 'base'
          });
        });
        xcSummaryLiveOptions.sort((a, b) => {
          return a.label.localeCompare(b.label, undefined, {
            numeric: true,
            sensitivity: 'base'
          });
        });
        this.meetList.xcEventSplits.forEach(eventSplit => {
          if (+eventSplit.number >= 0) {
            xcSummarySplitOptions.push({
              value: eventSplit.id + '---' + eventSplit.number + '---' + eventSplit.isFinal + '---' + eventSplit.split + '|||' + eventSplit.name + ' - ' + eventSplit.split,
              label: '#' + eventSplit.eventNumber + ') ' + eventSplit.name + ' - ' + eventSplit.split
            });
          }
          if (eventSplit.number == undefined) {
            xcSummarySplitOptions.push({
              value: eventSplit.id + '---0---true---Finish|||' + eventSplit.name + ' - Finish',
              label: '#' + eventSplit.eventNumber + ') ' + eventSplit.name + ' - Finish'
            });
          }
        });
        xcSummarySplitOptions.sort((a, b) => {
          return a.label.localeCompare(b.label, undefined, {
            numeric: true,
            sensitivity: 'base'
          });
        });
        xcSummaryOptions.push(...xcSummaryLiveOptions);
        xcSummaryOptions.push(...xcSummarySplitOptions);
        this.xcSummaryRaces.forEach(race => {
          this.xcSummaryOptionsByEvent[race.value] = [];
          this.xcSummaryOptionsByEvent[race.value] = xcSummaryOptions.filter(val => val.value.toString().split('---')[0] == race.value || val.value.toString().split('|||')[0] == race.value);
          this.xcSummaryOptionsByEvent[race.value].forEach(option => {
            const splitLength = option.label.split(' - ').length;
            option.label = option.label.split(' - ')[splitLength - 1];
          });
        });
      }
    }
    updateAthleticFieldDeviceNames() {
      const deviceNamesString = window.localStorage.getItem('asbFieldDeviceNames');
      const oldDeviceNames = this.athleticFieldDeviceNames;
      if (deviceNamesString) {
        this.athleticFieldDeviceNames = deviceNamesString.split(',');
      }
      if (oldDeviceNames !== this.athleticFieldDeviceNames) {
        this.getFieldResultOptions();
      }
    }
    getFieldResultOptions() {
      const fieldSelectOptions = [];
      if (this.athleticFieldDeviceNames) {
        this.athleticFieldDeviceNames.forEach(item => {
          fieldSelectOptions.push({
            value: item + '|||' + item,
            label: item
          });
        });
      }
      if (this.eventSummaries) {
        this.eventSummaries.forEach(event => {
          if (event.name && event.primaryEventGroup == 'Field') {
            fieldSelectOptions.push({
              value: event.roundId + '|||' + event.name,
              label: '#' + (event.number ?? event.roundId) + ') ' + event.name
            });
          }
        });
      }
      this.fieldSelectOptions = fieldSelectOptions;
      console.log('FIELD OPTIONS:', this.fieldSelectOptions);
    }
    // Allow selection of competition areas if you have more than one pit/circle for field result boards
    async getFieldCompetitionAreas(documentId) {
      if (documentId) {
        const roundId = documentId.split('|||')[0] ?? '';
        if (roundId) {
          const summary = await firstValueFrom(this.aliveFirebaseService.getLiveFieldEvent(this.meetId, roundId).pipe(filter(event => 'fieldEventOrientation' in event), switchMap(event => {
            if (event.fieldEventOrientation === 'Horizontal') {
              return this.aliveFirebaseService.getLiveHorizontalFieldSummary(this.meetId, roundId);
            } else if (event.fieldEventOrientation === 'Vertical') {
              return this.aliveFirebaseService.getLiveVerticalFieldSummary(this.meetId, roundId);
            } else {
              // shouldn't ever run, but gets rid of typing error
              return this.aliveFirebaseService.getLiveHorizontalFieldSummary(this.meetId, roundId);
            }
          })));
          console.log(summary.competitionArea);
          if (summary.competitionArea && Object.keys(summary.competitionArea).length > 1) {
            const eventCompetitionAreas = [];
            Object.keys(summary.competitionArea).forEach(id => {
              eventCompetitionAreas.push({
                value: id,
                label: summary.competitionArea[id].competitionArea.name
              });
            });
            eventCompetitionAreas.sort((a, b) => {
              return a.label.localeCompare(b.label, undefined, {
                numeric: true,
                sensitivity: 'base'
              });
            });
            this.fieldCompetitionAreasByEvent[documentId] = eventCompetitionAreas;
          }
        }
      }
    }
    static {
      this.ɵfac = function SetDataOptionsService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SetDataOptionsService)(i0.ɵɵinject(AthleticLiveFirebaseApiService), i0.ɵɵinject(AthleticLiveElasticApiService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: SetDataOptionsService,
        factory: SetDataOptionsService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return SetDataOptionsService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SetDataModalComponent = /*#__PURE__*/(() => {
  class SetDataModalComponent {
    constructor(setDataOptionsService, activeModal) {
      this.setDataOptionsService = setDataOptionsService;
      this.activeModal = activeModal;
      this.aliveRoles = [];
    }
    ngOnInit() {
      this.onModalOpen();
    }
    ngOnChanges(changes) {
      // auth from parent component takes time to load, so alive roles aren't immediately available
      if (changes['aliveRoles']) {
        this.hasMultipleScoreboardsRole = changes['aliveRoles'].currentValue.indexOf('ROLE_MULTIPLE_SCOREBOARDS') > -1;
        this.hasCheckInRole = changes['aliveRoles'].currentValue.indexOf('ROLE_CHECK_IN') > -1;
      }
    }
    onModalOpen() {
      console.log('RUNNING onModalOpen()');
      console.log(this.model);
      console.log(this.setDataOptionsService.meetList);
      console.log(this.setDataOptionsService.eventSummaries);
      this.updateTempDocumentOptions();
      if (this.setDataOptionsService.isXcMeet) {
        if (this.model.documentId) {
          if (this.model.documentId.split('---').length > 1) {
            this.xcSummarySelectedRace = +this.model.documentId.split('---')[0];
          } else {
            this.xcSummarySelectedRace = +this.model.documentId.split('|||')[0];
          }
        }
      } else {
        this.getFieldCompetitionAreas();
        this.updateAthletesForEvent();
        if (this.model.modelId === 'compiledResults') {
          this.updateTeamsForEvent();
        }
      }
      this.hasMultipleScoreboardsRole = this.aliveRoles.indexOf('ROLE_MULTIPLE_SCOREBOARDS') > -1;
      this.hasCheckInRole = this.aliveRoles.indexOf('ROLE_CHECK_IN') > -1;
    }
    updateTempDocumentOptions() {
      this.tempDocumentOptions = {
        documentType: this.model.documentType,
        documentId: this.model.documentId,
        documentSecondaryId: this.model.documentSecondaryId,
        documentOptions: this.model.documentOptions
      };
      // turn documentId and documentValue back into combined documentId
      if (this.model.documentId && this.model.documentValue) {
        if (this.model.documentId.includes('|||')) {
          this.tempDocumentOptions.documentId = this.model.documentId;
        }
        this.tempDocumentOptions.documentId = this.model.documentId + '|||' + this.model.documentValue.split('|||')[0];
      } else {
        this.tempDocumentOptions.documentId = '';
      }
      // turn documentSecondaryId and documentValue back into combined documentSecondaryId
      if (this.model.documentType === 'fieldEventCompetitionArea') {
        this.tempDocumentOptions.documentSecondaryId = this.model.documentSecondaryId + '|||' + this.model.documentValue.split('|||')[1];
      }
      if (this.model.documentType === 'fieldEventAthlete') {
        this.tempDocumentOptions.documentOptions.set('athleteId', this.model.documentOptions.get('athleteId') + '|||' + this.model.documentValue.split('|||')[1]);
      }
      // set heat/team back to all
      if (this.model.documentType === 'finalResult' && this.model.documentSecondaryId == null) {
        this.tempDocumentOptions.documentSecondaryId = 'all';
      }
      if (this.model.documentType === 'startList' && this.tempDocumentOptions.documentOptions.get('teamId') == null) {
        this.tempDocumentOptions.documentOptions.set('teamId', 'all');
      }
    }
    async onSave() {
      this.model.documentType = this.tempDocumentOptions.documentType;
      this.model.documentId = this.tempDocumentOptions.documentId;
      this.model.documentSecondaryId = this.tempDocumentOptions.documentSecondaryId;
      this.model.documentOptions = this.tempDocumentOptions.documentOptions;
      if (this.model.documentType === 'checkIn') {
        // don't need documentId, but need next block to run even on brand new board to upload boardData
        this.model.documentId = 'checkIn';
      }
      // TODO Note: We should convert everything over to documentOptions at some point
      // Update firebase with document info
      if (this.model.documentId && this.setDataOptionsService.meetList.id) {
        this.model.isSavingDocument = true;
        // document.getElementById(model.modelId + '-save-' + model.id).innerHTML = '<i class="fas fa-spin fa-spinner"></i>&nbsp;Save'
        // document.getElementById(model.modelId + '-set-data-column-' + model.id).innerHTML += '<div class="set-data-column-disabled">&nbsp;</div>'
        // Select box document ID looks like id|||name. Must split to get correct values.
        // To pass options, id|||name|||option1=yes|||option2=no
        // Special options:
        // - xcSummary.eventName = Display name
        // - adminName = text that describes what is showing now.
        // default to live field event if other options aren't available
        if ((this.model.modelId === 'fieldResult' || this.model.modelId === 'individualFieldResult') && !this.setDataOptionsService.fieldCompetitionAreasByEvent[this.model.documentId] && (!this.setDataOptionsService.fieldAthletesByEvent[this.model.documentId] || this.model.modelId === 'fieldResult')) {
          this.model.documentType = 'liveFieldEvent';
        }
        const documentIdParts = this.model.documentId.split('|||');
        this.model.documentId = documentIdParts[0];
        this.model.documentValue = documentIdParts[1];
        // default to first scoreboard if doesn't have ROLE_MULTIPLE_SCOREBOARDS
        if (!this.hasMultipleScoreboardsRole && (this.model.connectionType === 'online' && (this.model.modelId === 'lynxResultTime' || this.model.modelId === 'singleResultTime' || this.model.modelId === 'lynxTime') || this.model.modelId === 'compiledResults' && (this.model.documentType === 'liveTrackResult' || this.model.documentType === 'liveTrackStartList'))) {
          this.model.documentId = 'track';
        }
        if ((this.model.modelId === 'fieldResult' || this.model.modelId === 'individualFieldResult') && this.model.documentType === 'fieldEventCompetitionArea') {
          const documentSecondaryIdParts = this.model.documentSecondaryId.split('|||');
          this.model.documentValue = this.model.documentValue + '|||' + documentSecondaryIdParts[1];
          this.model.documentSecondaryId = documentSecondaryIdParts[0];
        }
        if ((this.model.modelId === 'fieldResult' || this.model.modelId === 'individualFieldResult') && this.model.documentType === 'fieldEventAthlete') {
          const documentOptionsAthleteParts = this.tempDocumentOptions.documentOptions.get('athleteId')?.split('|||');
          if (documentOptionsAthleteParts) {
            this.model.documentValue = this.model.documentValue + '|||' + documentOptionsAthleteParts[1];
            this.model.documentOptions.set('athleteId', documentOptionsAthleteParts[0]);
          }
        }
        const boardData = {
          documentId: this.model.documentId,
          meetId: this.setDataOptionsService.meetList.id,
          type: this.model.documentType ? this.model.documentType : '',
          options: {}
        };
        if (this.model.documentOptions) {
          console.log('document options', this.model.documentOptions);
          this.model.documentOptions.forEach((value, key) => {
            boardData.options[key] = value;
          });
        }
        if (this.model.documentType === 'liveTrackStartList') {
          this.model.documentSecondaryId = null;
        } else if (this.model.documentType === 'startList') {
          // Is the current meet XC
          if (this.setDataOptionsService.isXcMeet) {
            // No secondary ID for XC meets, but we need to set it to isXC
            this.model.documentSecondaryId = 'isXC';
          } else {
            // Check how many heats exist
            const compiledHeats = Object.keys(this.setDataOptionsService.heatsByEvent).find(key => key.split('|||')[0] === this.model.documentId);
            if (!compiledHeats || compiledHeats.length <= 1) {
              this.model.documentSecondaryId = null;
            }
          }
          if (this.tempDocumentOptions.documentOptions.get('teamId') === 'all') {
            this.tempDocumentOptions.documentOptions.set('teamId', null);
          }
        } else if (this.model.documentType === 'finalResult') {
          const numHeats = this.getNumHeatsForFinalResult();
          const selectedHeat = this.model.documentSecondaryId;
          if (numHeats.includes(+selectedHeat)) {
            this.model.documentSecondaryId = selectedHeat;
          } else {
            this.model.documentSecondaryId = null;
          }
        }
        if (this.model.documentSecondaryId) {
          boardData.options.documentSecondaryId = this.model.documentSecondaryId;
        }
        for (let i = 2, len = documentIdParts.length; i < len; i++) {
          const optionKeyValue = documentIdParts[i].split('=');
          boardData.options[optionKeyValue[0]] = optionKeyValue[1];
        }
        console.log('model', this.model);
        await this.updateBoard(this.model.id, boardData);
      }
      if (this.model.modelId === 'customMessageBoard') {
        // Save custom message board
        const boardData = {
          documentId: this.model.documentId,
          meetId: this.setDataOptionsService.meetList.id,
          type: this.model.documentType ? this.model.documentType : '',
          options: {}
        };
        if (this.model.documentOptions) {
          this.model.documentOptions.forEach((value, key) => {
            boardData.options[key] = value;
          });
        }
        await this.updateBoard(this.model.id, boardData);
      }
      // Save locally
      this.model.isSavingDocument = false;
      this.model.isEditingDocument = false;
      this.activeModal.close();
    }
    onCancel() {
      this.model.isEditingDocument = false;
      this.activeModal.dismiss();
    }
    // ensure options aren't carried over between document types
    clearExtraResultOptions() {
      if (this.model.modelId === 'compiledResults') {
        this.tempDocumentOptions.documentId = null;
      }
      this.tempDocumentOptions.documentSecondaryId = null;
      this.tempDocumentOptions.documentOptions.clear();
    }
    resetFieldDocumentType() {
      console.log('resetFieldDocumentType');
      this.tempDocumentOptions.documentType = 'liveFieldEvent';
    }
    getNumHeatsForFinalResult() {
      if (!this.tempDocumentOptions.documentId) {
        return [];
      }
      const eventId = this.tempDocumentOptions.documentId.replace('|||', '-').split('-')[1];
      const event = this.setDataOptionsService.eventSummaries.find(event => event.id === +eventId);
      if (!event) {
        return [];
      }
      // Only new events will have numHeats
      if (Object.keys(event).includes('numHeats')) {
        if (event.numHeats >= 1) {
          return Array.from({
            length: event.numHeats
          }, (_, i) => i + 1);
        }
      }
      return [];
    }
    updateXcSummaryFilter() {
      this.tempDocumentOptions.documentId = null;
      if (this.setDataOptionsService.xcSummaryOptionsByEvent[this.xcSummarySelectedRace].length === 1) {
        this.tempDocumentOptions.documentId = this.setDataOptionsService.xcSummaryOptionsByEvent[this.xcSummarySelectedRace][0].value.toString();
      }
    }
    updateTeamsForEvent(resetDocumentOptions = false) {
      if (this.tempDocumentOptions.documentId) {
        if (resetDocumentOptions) {
          // only reset these values when event selection changes, not when modal is opened
          this.tempDocumentOptions.documentOptions.set('teamId', undefined);
          this.tempDocumentOptions.documentOptions.set('sortMethod', '');
        }
        this.setDataOptionsService.updateTeamsForEvent(this.tempDocumentOptions.documentId);
      }
    }
    updateAthletesForEvent(resetDocumentOptions = false) {
      if (this.tempDocumentOptions.documentId) {
        if (resetDocumentOptions) {
          this.tempDocumentOptions.documentOptions.set('athleteId', undefined);
        }
        this.setDataOptionsService.updateAthletesForEvent(this.tempDocumentOptions.documentId);
      }
    }
    // Allow selection of competition areas if you have more than one pit/circle for field result boards
    getFieldCompetitionAreas() {
      if (this.tempDocumentOptions && this.tempDocumentOptions.documentId) {
        this.setDataOptionsService.getFieldCompetitionAreas(this.tempDocumentOptions.documentId);
      }
    }
    static {
      this.ɵfac = function SetDataModalComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SetDataModalComponent)(i0.ɵɵdirectiveInject(SetDataOptionsService), i0.ɵɵdirectiveInject(i2.NgbActiveModal));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SetDataModalComponent,
        selectors: [["app-set-data-modal"]],
        inputs: {
          model: "model",
          aliveRoles: "aliveRoles",
          updateBoard: "updateBoard"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 20,
        vars: 16,
        consts: [[1, "modal-header"], [1, "modal-title", "font-weight-bold", 3, "id"], ["type", "button", "aria-label", "Close", 1, "btn-close", 3, "click"], [1, "modal-body"], [1, "set-data-column-disabled"], [1, "row"], [1, "modal-footer"], ["type", "button", 1, "btn", "btn-secondary", 3, "click"], [1, "me-2", 3, "icon", "fixedWidth"], ["type", "button", 1, "btn", "btn-success", 3, "click", "disabled"], [1, "col-12", "mb-3"], ["for", "selectScoreboard", 1, "font-weight-bold"], ["id", "selectScoreboard", "placeholder", "Select a Scoreboard", 3, "ngModelChange", "ngModel", "searchable", "clearable"], ["value", "track|||Scoreboard 1"], ["value", "track2|||Scoreboard 2"], ["for", "raceTitle", 1, "font-weight-bold"], ["id", "raceTitle", "type", "text", "placeholder", "Race Title", 1, "form-control", 3, "ngModelChange", "ngModel"], ["for", "startOffset", 1, "font-weight-bold"], ["id", "startOffset", "type", "text", "placeholder", "Start Offset", 1, "form-control", 3, "ngModelChange", "ngModel"], ["for", "documentType", 1, "font-weight-bold"], ["id", "documentType", "placeholder", "Select a Document Type", 3, "ngModelChange", "change", "ngModel", "searchable", "clearable"], ["value", "finalResult"], ["value", "checkIn"], ["value", "startList"], ["value", "liveTrackResult"], ["value", "liveTrackStartList"], ["value", "teamScore"], [1, "col-6", "mb-3"], ["for", "select2EventSelector", 1, "font-weight-bold"], ["id", "select2EventSelector", "bindValue", "value", "placeholder", "Select an Event", 3, "ngModelChange", "change", "items", "ngModel"], ["for", "selectHeatCompiled", 1, "font-weight-bold"], ["id", "selectHeatCompiled", "placeholder", "Select a Heat", 3, "ngModelChange", "ngModel", "searchable", "clearable"], ["value", "all"], [3, "value"], ["for", "selectSortMethod", 1, "font-weight-bold"], ["id", "selectSortMethod", 3, "ngModelChange", "ngModel", "searchable", "clearable"], ["value", ""], ["value", "byTeam"], [1, "col-6"], ["for", "select2TeamSelector", 1, "font-weight-bold"], ["id", "select2TeamSelector", "bindValue", "value", "placeholder", "Select a team", 3, "ngModelChange", "items", "ngModel"], ["for", "selectScoreGroup", 1, "font-weight-bold"], ["id", "selectScoreGroup", "placeholder", "Select a Score Group", 3, "ngModelChange", "ngModel", "searchable", "clearable"], ["for", "xcSelectEvent", 1, "font-weight-bold"], ["id", "xcSelectEvent", "bindValue", "value", "placeholder", "Select a Race", 3, "ngModelChange", "change", "items", "ngModel"], ["for", "xcSelectSplit", 1, "font-weight-bold"], ["id", "xcSelectSplit", "bindValue", "value", "placeholder", "Select a Split", 3, "ngModelChange", "items", "ngModel"], ["for", "fieldSelectEvent", 1, "font-weight-bold"], ["id", "fieldSelectEvent", "bindValue", "value", "placeholder", "Select an Event", 3, "ngModelChange", "change", "items", "ngModel"], [1, "col-12"], ["for", "fieldResultDocumentTypeSelection", 1, "font-weight-bold"], ["id", "fieldResultDocumentTypeSelection", "placeholder", "Select a Data Source", 3, "ngModelChange", "change", "ngModel", "searchable", "clearable"], ["value", "liveFieldEvent"], ["value", "fieldEventCompetitionArea"], ["value", "fieldEventAthlete"], ["for", "fieldResultCompetitionAreaSelection", 1, "font-weight-bold"], ["id", "fieldResultCompetitionAreaSelection", "placeholder", "Select a Competition Area", 3, "ngModelChange", "ngModel", "searchable", "clearable"], ["for", "fieldResultAthleteSelection", 1, "font-weight-bold"], ["id", "fieldResultAthleteSelection", "bindValue", "value", "placeholder", "Select an Athlete", 3, "ngModelChange", "items", "ngModel"], ["for", "lineOne", 1, "font-weight-bold"], ["id", "lineOne", "type", "text", "placeholder", "Enter text for line 1", 1, "form-control", 3, "ngModelChange", "ngModel"], ["for", "lineTwo", 1, "font-weight-bold"], ["id", "lineTwo", "type", "text", "placeholder", "Enter text for line 2", 1, "form-control", 3, "ngModelChange", "ngModel"], ["for", "lineThree", 1, "font-weight-bold"], ["id", "lineThree", "type", "text", "placeholder", "Enter text for line 3", 1, "form-control", 3, "ngModelChange", "ngModel"], ["animation", "spin-pulse", 1, "me-2", 3, "icon", "fixedWidth"]],
        template: function SetDataModalComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "h5", 1);
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "button", 2);
            i0.ɵɵlistener("click", function SetDataModalComponent_Template_button_click_3_listener() {
              return ctx.onCancel();
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(4, "div", 3)(5, "div", 4);
            i0.ɵɵtext(6, "\xA0");
            i0.ɵɵelementEnd();
            i0.ɵɵconditionalCreate(7, SetDataModalComponent_Conditional_7_Template, 2, 1);
            i0.ɵɵconditionalCreate(8, SetDataModalComponent_Conditional_8_Template, 2, 1);
            i0.ɵɵconditionalCreate(9, SetDataModalComponent_Conditional_9_Template, 16, 9, "div");
            i0.ɵɵconditionalCreate(10, SetDataModalComponent_Conditional_10_Template, 2, 1);
            i0.ɵɵconditionalCreate(11, SetDataModalComponent_Conditional_11_Template, 2, 1);
            i0.ɵɵconditionalCreate(12, SetDataModalComponent_Conditional_12_Template, 13, 3, "div", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(13, "div", 6)(14, "button", 7);
            i0.ɵɵlistener("click", function SetDataModalComponent_Template_button_click_14_listener() {
              return ctx.onCancel();
            });
            i0.ɵɵelement(15, "fa-icon", 8);
            i0.ɵɵtext(16, "Cancel ");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(17, "button", 9);
            i0.ɵɵlistener("click", function SetDataModalComponent_Template_button_click_17_listener() {
              return ctx.onSave();
            });
            i0.ɵɵconditionalCreate(18, SetDataModalComponent_Conditional_18_Template, 2, 3);
            i0.ɵɵconditionalCreate(19, SetDataModalComponent_Conditional_19_Template, 2, 3);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("id", "setDataModal_" + ctx.model.id + "Label");
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1("Set Data - ", ctx.model == null ? null : ctx.model.name);
            i0.ɵɵadvance(3);
            i0.ɵɵstyleProp("display", (ctx.model == null ? null : ctx.model.isSavingDocument) ? "block" : "none");
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.model.modelId === "lynxResultTime" || ctx.model.modelId === "singleResultTime" ? 7 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.model.modelId === "lynxTime" ? 8 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.model.modelId === "compiledResults" ? 9 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.model.modelId === "xcSummary" ? 10 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.model.modelId === "fieldResult" || ctx.model.modelId === "individualFieldResult" ? 11 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.model.modelId === "customMessageBoard" ? 12 : -1);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("icon", i0.ɵɵpureFunction0(15, _c0))("fixedWidth", true);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("disabled", ctx.model == null ? null : ctx.model.isSavingDocument);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!(ctx.model == null ? null : ctx.model.isSavingDocument) ? 18 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional((ctx.model == null ? null : ctx.model.isSavingDocument) ? 19 : -1);
          }
        },
        dependencies: [NgSelectModule, i3.NgSelectComponent, i3.NgOptionComponent, FormsModule, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgModel, FaIconComponent],
        styles: [".set-data-column-disabled[_ngcontent-%COMP%]{position:absolute;inset:0;background-color:rgba(var(--bs-body-bg-rgb),.8);z-index:1000;display:flex;align-items:center;justify-content:center}.fa-spinner[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_spin 1s linear infinite}@keyframes _ngcontent-%COMP%_spin{0%{transform:rotate(0)}to{transform:rotate(360deg)}}"]
      });
    }
  }
  return SetDataModalComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SelectedDataComponent = /*#__PURE__*/(() => {
  class SelectedDataComponent {
    constructor(setDataOptionsService) {
      this.setDataOptionsService = setDataOptionsService;
      this.aliveRoles = [];
      this.hasMultipleScoreboardsRole = this.aliveRoles.indexOf('ROLE_MULTIPLE_SCOREBOARDS') > -1;
    }
    ngOnChanges(changes) {
      // auth from parent component takes time to load, so alive roles aren't immediately available
      if (changes['aliveRoles']) {
        this.hasMultipleScoreboardsRole = changes['aliveRoles'].currentValue.indexOf('ROLE_MULTIPLE_SCOREBOARDS') > -1;
      }
    }
    documentTypeToLabel(documentType) {
      switch (documentType) {
        case 'liveTrackStartList':
          return 'Live Track Start List';
        case 'liveTrackResult':
          return 'Live Track Result';
        case 'startList':
          return 'Start List';
        case 'finalResult':
          return 'Final Result';
        case 'xcSummary':
          return 'XC Summary';
        case 'teamScore':
          return 'Team Score';
        case 'checkIn':
          return 'Check In Status';
        case 'liveFieldEvent':
          return 'Live';
        case 'fieldEventCompetitionArea':
          return 'Competition Area';
        case 'fieldEventAthlete':
          return 'Athlete';
        default:
          return documentType;
      }
    }
    static {
      this.ɵfac = function SelectedDataComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SelectedDataComponent)(i0.ɵɵdirectiveInject(SetDataOptionsService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SelectedDataComponent,
        selectors: [["app-selected-data"]],
        inputs: {
          model: "model",
          aliveRoles: "aliveRoles"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 6,
        vars: 6,
        consts: [[1, "d-flex", "w-100", "align-items-center"], [1, "d-flex", "justify-content-between", "align-items-start"], [1, "flex-grow-1", "d-flex", "flex-wrap", "align-items-center", 2, "gap", "0.5rem"], [2, "width", "min-content"], [1, "badge", "text-bg-secondary", 2, "font-size", "inherit !important"]],
        template: function SelectedDataComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵconditionalCreate(0, SelectedDataComponent_Conditional_0_Template, 2, 1);
            i0.ɵɵconditionalCreate(1, SelectedDataComponent_Conditional_1_Template, 2, 1);
            i0.ɵɵconditionalCreate(2, SelectedDataComponent_Conditional_2_Template, 3, 1, "div", 0);
            i0.ɵɵconditionalCreate(3, SelectedDataComponent_Conditional_3_Template, 1, 1);
            i0.ɵɵconditionalCreate(4, SelectedDataComponent_Conditional_4_Template, 7, 4, "div", 0);
            i0.ɵɵconditionalCreate(5, SelectedDataComponent_Conditional_5_Template, 14, 3, "div", 1);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.model.modelId === "lynxResultTime" || ctx.model.modelId === "singleResultTime" ? 0 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.model.modelId === "lynxTime" ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.model.modelId === "compiledResults" ? 2 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.model.modelId === "xcSummary" ? 3 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.model.modelId === "fieldResult" || ctx.model.modelId === "individualFieldResult" ? 4 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.model.modelId === "customMessageBoard" ? 5 : -1);
          }
        },
        encapsulation: 2
      });
    }
  }
  return SelectedDataComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Provides the Athletic Live Elastic API service with configuration.
 * This is the modern standalone approach for Angular 20+.
 *
 * @param config Configuration for API endpoints
 * @returns Environment providers for the Elastic API service
 */
function provideAthleticLiveElasticApi(config) {
  return makeEnvironmentProviders([provideHttpClient(), {
    provide: ATHLETIC_LIVE_API_CONFIG,
    useValue: config || {}
  }]);
}

/*
 * Public API Surface of athletic-live-api
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ATHLETIC_LIVE_API_CONFIG, AthleticLiveElasticApiService, AthleticLiveFirebaseApiService, SelectedDataComponent, SetDataModalComponent, SetDataOptionsService, provideAthleticLiveElasticApi };
